(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lohnr-collection-editorial-v7"] && !Shopify.designMode) return;
  try {
    
/*
  LOHNR Collection Editorial v7.3 - bundled JavaScript
  Collection-page interactions.
  7.3: native :hover action visibility, interaction-safe hover suppression, and direct image-2-to-image-3 crossfade.
*/

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-lhc-module]';
  var CARD_SELECTOR = '[data-lhc-card]';
  var DIALOG_OPEN_CLASS = 'lhc-dialog-open';
  var STATE_MAX_AGE = 30 * 60 * 1000;
  var COLOR_FALLBACKS = {
    black: '#111111',
    white: '#ffffff',
    ivory: '#f5f0e6',
    cream: '#f3ead8',
    beige: '#d6c3a5',
    tan: '#b58b62',
    brown: '#6f4e37',
    grey: '#8a8a86',
    gray: '#8a8a86',
    charcoal: '#3f4244',
    navy: '#18263d',
    blue: '#496d9b',
    green: '#566e55',
    olive: '#73754c',
    red: '#a93232',
    burgundy: '#6d2332',
    pink: '#d69aa8',
    purple: '#755985',
    orange: '#c97942',
    yellow: '#d6b95d'
  };

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function safeJson(element, fallback) {
    if (!element) return fallback;

    try {
      return JSON.parse(element.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function viewportShare(columns) {
    var count = Math.max(1, parseInt(columns, 10) || 1);
    return String(Math.round((100 / count) * 1000) / 1000) + 'vw';
  }

  function routeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function cartAddUrl() {
    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url;
    }
    return routeRoot() + 'cart/add.js';
  }

  function cartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) {
      return window.routes.cart_update_url;
    }
    return routeRoot() + 'cart/update.js';
  }

  function cartPageUrl() {
    if (window.routes && window.routes.cart_url) {
      return window.routes.cart_url;
    }
    return routeRoot() + 'cart';
  }

  function openDialog(dialog) {
    if (!dialog) return false;

    document.body.classList.add(DIALOG_OPEN_CLASS);

    try {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      return true;
    } catch (error) {
      document.body.classList.remove(DIALOG_OPEN_CLASS);
      return false;
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      document.body.classList.remove(DIALOG_OPEN_CLASS);
    }
  }

  function replaceUrlVariant(url, variantId) {
    if (!url || !variantId) return url;

    try {
      var parsedUrl = new URL(url, document.baseURI || window.location.href);
      parsedUrl.searchParams.set('variant', String(variantId));
      return parsedUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function navigationType() {
    if (!window.performance || typeof window.performance.getEntriesByType !== 'function') {
      return '';
    }

    var entries = window.performance.getEntriesByType('navigation');
    return entries && entries[0] ? entries[0].type : '';
  }

  function isReducedMotion() {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function isHoverDevice() {
    return Boolean(window.matchMedia && window.matchMedia('(hover: hover)').matches);
  }

  function uniqueBy(items, keyFunction) {
    var seen = Object.create(null);

    return items.filter(function (item) {
      var key = String(keyFunction(item));
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function extractHexColor(value) {
    var text = String(value || '').trim();
    var match = text.match(/#(?:[0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})(?![0-9a-f])/i);
    if (match) return match[0].toLowerCase();

    if (/^(?:[0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i.test(text)) {
      return '#' + text.toLowerCase();
    }

    return '';
  }

  function isUsableCssColor(value) {
    if (!value) return false;
    if (window.CSS && typeof window.CSS.supports === 'function') {
      return window.CSS.supports('color', value);
    }
    return true;
  }

  function fallbackColorForName(value) {
    var normalized = String(value || '')
      .toLowerCase()
      .replace(/[^a-z]+/g, ' ')
      .trim();

    if (COLOR_FALLBACKS[normalized]) return COLOR_FALLBACKS[normalized];

    var keys = Object.keys(COLOR_FALLBACKS);
    for (var index = 0; index < keys.length; index += 1) {
      if (normalized.split(' ').indexOf(keys[index]) !== -1) return COLOR_FALLBACKS[keys[index]];
    }

    return '#d8d8d4';
  }

  function resolveSwatchColor(swatch) {
    if (!swatch) return '#d8d8d4';

    var altColor = extractHexColor(swatch.getAttribute('data-lhc-swatch-alt'));
    if (altColor) return altColor;

    var storedColor = String(swatch.getAttribute('data-lhc-swatch-color') || '').trim();
    if (isUsableCssColor(storedColor)) return storedColor;

    return fallbackColorForName(swatch.getAttribute('data-lhc-color'));
  }

  function mediaFromTemplates(card) {
    return toArray(card.querySelectorAll('[data-lhc-media-template]')).map(function (template) {
      return {
        c: template.getAttribute('data-lhc-media-color') || '',
        u: template.getAttribute('data-lhc-media-src') || '',
        s: template.getAttribute('data-lhc-media-srcset') || '',
        w: parseInt(template.getAttribute('data-lhc-media-width'), 10) || 0,
        h: parseInt(template.getAttribute('data-lhc-media-height'), 10) || 0,
        a: template.getAttribute('data-lhc-media-alt') || ''
      };
    }).filter(function (item) {
      return Boolean(item.u);
    });
  }

  function mediaFromRenderedSlides(card) {
    return toArray(card.querySelectorAll('[data-lhc-carousel-track] .lhc-carousel-slide')).map(function (slide) {
      var image = slide.querySelector('img');
      if (!image) return null;
      return {
        c: slide.getAttribute('data-lhc-media-color') || '',
        u: image.currentSrc || image.getAttribute('src') || '',
        s: image.getAttribute('srcset') || '',
        w: image.naturalWidth || parseInt(image.getAttribute('width'), 10) || 0,
        h: image.naturalHeight || parseInt(image.getAttribute('height'), 10) || 0,
        a: image.getAttribute('alt') || ''
      };
    }).filter(Boolean);
  }

  function createMediaImage(item, options) {
    var settings = options || {};
    var image = document.createElement('img');
    image.src = item && item.u ? item.u : '';
    if (item && item.s) image.srcset = item.s;
    if (settings.sizes) image.sizes = settings.sizes;
    image.alt = item && item.a ? item.a : (settings.alt || '');
    image.loading = settings.eager ? 'eager' : 'lazy';
    image.decoding = 'async';
    if (item && item.w) image.width = item.w;
    if (item && item.h) image.height = item.h;
    return image;
  }

  function LohnrCollection(root) {
    this.root = root;
    this.grid = root.querySelector('[data-lhc-grid]');
    this.filterDialog = root.querySelector('[data-lhc-filter-dialog]');
    this.quickDialog = root.querySelector('[data-lhc-quick-dialog]');
    this.quickGallery = root.querySelector('[data-lhc-quick-gallery]');
    this.quickGalleryTrack = root.querySelector('[data-lhc-quick-gallery-track]');
    this.quickGalleryPrevious = root.querySelector('[data-lhc-quick-gallery-prev]');
    this.quickGalleryNext = root.querySelector('[data-lhc-quick-gallery-next]');
    this.quickGalleryCurrent = root.querySelector('[data-lhc-quick-gallery-current]');
    this.quickGalleryTotal = root.querySelector('[data-lhc-quick-gallery-total]');
    this.quickGalleryProgress = root.querySelector('[data-lhc-quick-gallery-progress]');
    this.quickGalleryProgressBar = root.querySelector('[data-lhc-quick-gallery-progress-bar]');
    this.quickTitle = root.querySelector('[data-lhc-quick-title]');
    this.quickPrice = root.querySelector('[data-lhc-quick-price]');
    this.quickColor = root.querySelector('[data-lhc-quick-color]');
    this.quickColorGroup = root.querySelector('[data-lhc-quick-color-group]');
    this.quickSwatches = root.querySelector('[data-lhc-quick-swatches]');
    this.quickSizes = root.querySelector('[data-lhc-quick-sizes]');
    this.quickSizeLabel = root.querySelector('[data-lhc-quick-size-label]');
    this.quickAddButton = root.querySelector('[data-lhc-quick-add]');
    this.quickProductLink = root.querySelector('[data-lhc-quick-product-link]');
    this.quickStatus = root.querySelector('[data-lhc-quick-status]');
    this.activeQuickCard = null;
    this.filterTrigger = null;
    this.quickTrigger = null;
    this.quickSelectedVariant = null;
    this.loadedPages = 1;
    this.isAdding = false;
    this.prefetchCache = new Map();
    this.prefetchObserver = null;
    this.stateKey = 'lohnr:collection:v7:' + window.location.pathname + window.location.search;
    this.sectionId = root.getAttribute('data-lhc-section-id') || '';
    this.stickyTicking = false;
    this.restoreInProgress = false;
    this.cleanupCallbacks = [];
    this.eventController = typeof AbortController === 'function' ? new AbortController() : null;
    this.eventSignal = this.eventController ? this.eventController.signal : null;
    this.collectionRequestController = null;
    this.collectionRequestId = 0;
    this.editorialTicking = false;
    this.lastInputMethod = 'pointer';
  }

  LohnrCollection.prototype.listen = function (target, eventName, handler, options) {
    if (!target || typeof target.addEventListener !== 'function') return;

    var normalizedOptions = options;
    if (this.eventSignal) {
      if (typeof options === 'boolean') {
        normalizedOptions = { capture: options, signal: this.eventSignal };
      } else {
        normalizedOptions = Object.assign({}, options || {}, { signal: this.eventSignal });
      }

      try {
        target.addEventListener(eventName, handler, normalizedOptions);
        return;
      } catch (error) {}
    }

    target.addEventListener(eventName, handler, options);
    var capture = typeof options === 'boolean' ? options : Boolean(options && options.capture);
    this.cleanupCallbacks.push(function () {
      target.removeEventListener(eventName, handler, capture);
    });
  };

  LohnrCollection.prototype.init = function () {
    if (this.root.dataset.lhcInitialized === 'true') return;
    this.root.dataset.lhcInitialized = 'true';
    if (window.console && typeof window.console.info === 'function') {
      window.console.info('[LOHNR] Collection release 7.5.0 Shrine cart fix loaded');
    }

    this.initializeCards(this.root);
    this.initializeEditorialTiles(this.root);
    this.initializeQuickGallery();
    this.initializeRail();
    this.initializeCollectionMenu();
    this.initializeDensity();
    this.initializeStickyOffset();
    this.initializeDialogs();
    this.initializeSorting();
    this.bindEvents();
    this.observeLoadMore();
    this.restoreState();
  };

  LohnrCollection.prototype.initializeCards = function (scope) {
    var instance = this;

    toArray(scope.querySelectorAll(CARD_SELECTOR)).forEach(function (card) {
      instance.initializeCard(card);
    });
  };

  LohnrCollection.prototype.initializeCard = function (card) {
    if (!card || card.dataset.lhcReady === 'true') return;
    card.dataset.lhcReady = 'true';

    card._lhcVariants = safeJson(card.querySelector('[data-lhc-variant-data]'), []);
    card._lhcMedia = mediaFromTemplates(card);
    if (!card._lhcMedia.length) card._lhcMedia = safeJson(card.querySelector('[data-lhc-media-data]'), []);
    if (!card._lhcMedia.length) card._lhcMedia = mediaFromRenderedSlides(card);
    card._lhcColors = safeJson(card.querySelector('[data-lhc-color-data]'), []);
    card._lhcWarmColors = new Set();
    this.initializeSwatches(card);

    var media = card.querySelector('[data-lhc-media]');
    var track = card.querySelector('[data-lhc-carousel-track]');
    var instance = this;

    var resetCardHoverState = function () {
      card.removeAttribute('data-lhc-hover-suppressed');
      var preview = card.querySelector('[data-lhc-hover-preview]');
      if (preview) preview.classList.remove('is-committing', 'is-releasing');
    };

    this.listen(card, 'mouseenter', function () {
      resetCardHoverState();
    });

    this.listen(card, 'mouseleave', function () {
      resetCardHoverState();
    });

    this.listen(card, 'pointerleave', function () {
      if (!card.matches(':hover')) resetCardHoverState();
    });

    this.listen(card, 'pointerdown', function () {
      instance.lastInputMethod = 'pointer';
    });

    if (track && media) {
      var ticking = false;
      this.listen(
        track,
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            instance.updateCarousel(media);
            ticking = false;
          });
        },
        { passive: true }
      );
      this.updateCarousel(media);
    }

    var selectedColor = this.getSelectedColor(card);
    var representativeVariant = this.getRepresentativeVariant(card, selectedColor);
    if (representativeVariant) {
      this.updateCardLinks(card, representativeVariant.id);
      this.updateCardPrice(card, representativeVariant);
      this.updateCardBadge(card, representativeVariant);
      this.updateCardAction(card, representativeVariant);
      if (this.galleryColorMode() === 'all_sync') {
        this.renderMedia(card, selectedColor, representativeVariant, { instant: true });
      }
      this.updateHoverPreview(card, selectedColor);
    }
  };

  LohnrCollection.prototype.initializeSwatches = function (card) {
    toArray(card.querySelectorAll('[data-lhc-swatch]')).forEach(function (swatch) {
      var color = resolveSwatchColor(swatch);
      swatch.setAttribute('data-lhc-swatch-color', color);
      swatch.style.setProperty('--lhc-swatch-color', color);
      swatch.style.removeProperty('--lhc-swatch-image');
    });
  };

  LohnrCollection.prototype.getColorIndex = function (card) {
    var parsed = parseInt(card.getAttribute('data-lhc-color-index'), 10);
    return Number.isNaN(parsed) ? -1 : parsed;
  };

  LohnrCollection.prototype.getSizeIndex = function (card) {
    var parsed = parseInt(card.getAttribute('data-lhc-size-index'), 10);
    return Number.isNaN(parsed) ? -1 : parsed;
  };

  LohnrCollection.prototype.getSelectedColor = function (card) {
    var selected = card.querySelector('[data-lhc-selected-color]');
    return selected ? selected.textContent.trim() : '';
  };

  LohnrCollection.prototype.getVariantsForColor = function (card, colorName) {
    var variants = card._lhcVariants || [];
    var colorIndex = this.getColorIndex(card);

    if (colorIndex < 0) return variants.slice();

    return variants.filter(function (variant) {
      return String(variant.o[colorIndex]) === String(colorName);
    });
  };

  LohnrCollection.prototype.getRepresentativeVariant = function (card, colorName) {
    var variants = this.getVariantsForColor(card, colorName);
    if (!variants.length) return null;

    return (
      variants.find(function (variant) {
        return Boolean(variant.a);
      }) || variants[0]
    );
  };

  LohnrCollection.prototype.updateCardLinks = function (card, variantId) {
    toArray(card.querySelectorAll('[data-lhc-product-link]')).forEach(function (link) {
      link.href = replaceUrlVariant(link.href, variantId);
    });
  };

  LohnrCollection.prototype.renderPrice = function (container, variant) {
    if (!container || !variant) return;

    container.textContent = '';

    if (variant.c && variant.c > variant.p) {
      var sale = document.createElement('span');
      sale.className = 'lhc-price-sale';
      sale.textContent = variant.pf;

      var compare = document.createElement('span');
      compare.className = 'lhc-price-compare';
      compare.textContent = variant.cf;

      container.appendChild(sale);
      container.appendChild(compare);
    } else {
      var regular = document.createElement('span');
      regular.className = 'lhc-price-regular';
      regular.textContent = variant.pf;
      container.appendChild(regular);
    }
  };

  LohnrCollection.prototype.updateCardPrice = function (card, variant) {
    this.renderPrice(card.querySelector('[data-lhc-price]'), variant);
  };

  LohnrCollection.prototype.updateCardBadge = function (card, representativeVariant) {
    var stack = card.querySelector('[data-lhc-badge-stack]');
    var badge = card.querySelector('[data-lhc-badge]');
    if (!stack || !badge) return;

    var variants = this.getVariantsForColor(card, this.getSelectedColor(card));
    var hasAvailable = variants.some(function (variant) {
      return Boolean(variant.a);
    });
    var text = '';

    if (!hasAvailable) {
      text = 'Sold out';
    } else if (representativeVariant && representativeVariant.c && representativeVariant.c > representativeVariant.p) {
      text = 'Sale';
    } else {
      text = card.getAttribute('data-lhc-tag-badge') || '';
    }

    badge.textContent = text;
    badge.classList.toggle('lhc-badge--sale', text === 'Sale');
    stack.hidden = !text;
  };

  LohnrCollection.prototype.updateCardAction = function (card, representativeVariant) {
    var action = card.querySelector('[data-lhc-card-action]');
    var label = action ? action.querySelector('[data-lhc-action-label]') : null;
    if (!action || !label) return;

    var isComplex = card.getAttribute('data-lhc-complex') === 'true';
    var sizeIndex = this.getSizeIndex(card);
    var productTitle = card.getAttribute('data-lhc-product-title') || 'product';
    var variants = this.getVariantsForColor(card, this.getSelectedColor(card));
    var hasAvailable = variants.some(function (variant) {
      return Boolean(variant.a);
    });

    if (isComplex) {
      label.textContent = 'Select options';
      action.removeAttribute('disabled');
      action.setAttribute('aria-disabled', 'false');
      action.setAttribute('aria-label', 'Select options for ' + productTitle);
      if (representativeVariant) {
        action.href = replaceUrlVariant(action.href, representativeVariant.id);
      }
      return;
    }

    if (action.tagName === 'A') return;

    if (sizeIndex >= 0) {
      label.textContent = hasAvailable ? 'Quick add' : 'Sold out';
      action.disabled = !hasAvailable;
      action.setAttribute('aria-label', hasAvailable ? 'Quick add ' + productTitle : productTitle + ' sold out');
    } else {
      var canAdd = Boolean(representativeVariant && representativeVariant.a);
      label.textContent = canAdd ? 'Add to bag' : 'Sold out';
      action.disabled = !canAdd;
      action.setAttribute('aria-label', canAdd ? 'Add ' + productTitle + ' to bag' : productTitle + ' sold out');
      if (representativeVariant) action.setAttribute('data-lhc-variant-id', String(representativeVariant.id));
    }
  };

  LohnrCollection.prototype.galleryColorMode = function () {
    return this.root.getAttribute('data-gallery-color-mode') === 'all_sync' ? 'all_sync' : 'selected_only';
  };

  LohnrCollection.prototype.mediaForColor = function (card, colorName) {
    var media = card._lhcMedia || [];
    var colorIndex = this.getColorIndex(card);
    var selected = media.filter(function (item) {
      if (colorIndex < 0) return true;
      return String(item.c) === String(colorName);
    });

    if (!selected.length && media.length) {
      var fallbackColor = media[0].c;
      selected = media.filter(function (item) {
        return String(item.c) === String(fallbackColor);
      });
    }

    return selected;
  };

  LohnrCollection.prototype.galleryMedia = function (card, colorName) {
    if (this.galleryColorMode() === 'all_sync' && this.getColorIndex(card) >= 0) {
      return (card._lhcMedia || []).slice();
    }
    return this.mediaForColor(card, colorName);
  };

  LohnrCollection.prototype.updateHoverPreview = function (card, colorName) {
    if (!card) return;

    var existing = card.querySelector('[data-lhc-hover-preview]');
    var enabled = this.root.getAttribute('data-hover-second-image') === 'true';
    if (!enabled) {
      if (existing) existing.remove();
      return;
    }

    var items = this.mediaForColor(card, colorName);
    if (items.length < 2) {
      if (existing) existing.remove();
      return;
    }

    var preview = existing || document.createElement('div');
    preview.className = 'lhc-hover-preview';
    preview.setAttribute('data-lhc-hover-preview', '');
    preview.textContent = '';
    preview.appendChild(createMediaImage(items[1], {
      sizes: this.imageSizes(this.root.getAttribute('data-grid-density') || 'compact'),
      alt: card.getAttribute('data-lhc-product-title') || '',
      eager: false
    }));

    if (!existing) {
      var media = card.querySelector('[data-lhc-media]');
      if (media) media.appendChild(preview);
    }
  };

  LohnrCollection.prototype.renderMedia = function (card, colorName, representativeVariant, options) {
    var mediaWrapper = card.querySelector('[data-lhc-media]');
    var track = card.querySelector('[data-lhc-carousel-track]');
    if (!mediaWrapper || !track) return;

    var settings = options || {};
    var items = this.galleryMedia(card, colorName);
    if (!items.length) return;

    mediaWrapper.setAttribute('aria-busy', 'true');
    track.textContent = '';

    var productTitle = card.getAttribute('data-lhc-product-title') || '';
    var productUrl = card.getAttribute('data-lhc-product-url') || window.location.href;
    var variantUrl = replaceUrlVariant(productUrl, representativeVariant ? representativeVariant.id : null);
    var density = this.root.getAttribute('data-grid-density') || 'compact';
    var sizes = this.imageSizes(density);
    var targetIndex = this.galleryColorMode() === 'all_sync'
      ? items.findIndex(function (item) { return String(item.c) === String(colorName); })
      : 0;
    if (targetIndex < 0) targetIndex = 0;

    items.forEach(function (item, index) {
      var link = document.createElement('a');
      link.className = 'lhc-carousel-slide';
      link.href = variantUrl;
      link.setAttribute('data-lhc-product-link', '');
      link.setAttribute('data-lhc-media-color', String(item.c || ''));
      link.setAttribute('aria-label', 'View ' + productTitle + (index > 0 ? ', image ' + (index + 1) : ''));

      var image = createMediaImage(item, {
        sizes: sizes,
        alt: productTitle,
        eager: index === targetIndex
      });

      link.appendChild(image);
      track.appendChild(link);
    });

    track.scrollLeft = targetIndex * Math.max(track.clientWidth, 1);
    this.updateCarousel(mediaWrapper, { skipColorSync: true });

    var targetImage = track.children[targetIndex] ? track.children[targetIndex].querySelector('img') : track.querySelector('img');
    var finish = function () {
      mediaWrapper.removeAttribute('aria-busy');
    };

    if (!targetImage) {
      finish();
    } else if (typeof targetImage.decode === 'function') {
      targetImage.decode().catch(function () {}).then(finish);
    } else if (targetImage.complete) {
      finish();
    } else {
      targetImage.addEventListener('load', finish, { once: true });
      targetImage.addEventListener('error', finish, { once: true });
    }

    if (!settings.instant && !isReducedMotion()) {
      track.scrollTo({ left: targetIndex * Math.max(track.clientWidth, 1), behavior: 'smooth' });
    }
  };

  LohnrCollection.prototype.imageSizes = function (density) {
    var mobileColumns = this.root.getAttribute('data-mobile-columns') || '2';
    var mobileSize = viewportShare(mobileColumns);

    if (density === 'large') {
      var largeColumns = this.root.getAttribute('data-large-columns') || '3';
      return '(max-width: 749px) ' + mobileSize + ', (max-width: 1099px) 50vw, ' + viewportShare(largeColumns);
    }

    var compactColumns = this.root.getAttribute('data-compact-columns') || '4';
    return '(max-width: 749px) ' + mobileSize + ', (max-width: 1099px) 33.333vw, ' + viewportShare(compactColumns);
  };

  LohnrCollection.prototype.updateImageSizes = function () {
    var sizes = this.imageSizes(this.root.getAttribute('data-grid-density') || 'compact');
    toArray(this.root.querySelectorAll('.lhc-carousel-slide img')).forEach(function (image) {
      image.sizes = sizes;
    });
  };

  LohnrCollection.prototype.updateCarousel = function (mediaWrapper, options) {
    if (!mediaWrapper) return;

    var track = mediaWrapper.querySelector('[data-lhc-carousel-track]');
    var current = mediaWrapper.querySelector('[data-lhc-carousel-current]');
    var total = mediaWrapper.querySelector('[data-lhc-carousel-total]');
    var previous = mediaWrapper.querySelector('[data-lhc-carousel-prev]');
    var next = mediaWrapper.querySelector('[data-lhc-carousel-next]');
    var count = track ? track.children.length : 0;
    count = Math.max(1, count);

    mediaWrapper.setAttribute('data-slide-count', String(count));
    if (total) total.textContent = String(count);

    var index = 0;
    if (track && count > 1) {
      index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      index = clamp(index, 0, count - 1);
    }

    mediaWrapper.setAttribute('data-active-slide', String(index));
    if (current) current.textContent = String(index + 1);
    if (previous) previous.disabled = count <= 1 || index === 0;
    if (next) next.disabled = count <= 1 || index >= count - 1;

    if (this.galleryColorMode() === 'all_sync' && !(options && options.skipColorSync) && track && track.children[index]) {
      var card = mediaWrapper.closest(CARD_SELECTOR);
      var activeColor = track.children[index].getAttribute('data-lhc-media-color') || '';
      if (card && activeColor && activeColor !== this.getSelectedColor(card)) {
        this.selectColor(card, activeColor, false, { skipMedia: true });
      }
    }
  };

  LohnrCollection.prototype.isHoverPreviewVisible = function (mediaWrapper) {
    if (!mediaWrapper || !isHoverDevice()) return false;
    if (this.root.getAttribute('data-hover-second-image') !== 'true') return false;
    if (mediaWrapper.getAttribute('data-active-slide') !== '0') return false;

    var card = mediaWrapper.closest(CARD_SELECTOR);
    var preview = mediaWrapper.querySelector('[data-lhc-hover-preview]');
    if (!card || !preview) return false;
    if (!card.matches(':hover')) return false;
    if (card.getAttribute('data-lhc-hover-suppressed') === 'true') return false;
    return true;
  };

  LohnrCollection.prototype.navigateCardGallery = function (mediaWrapper, direction) {
    if (!mediaWrapper || !direction) return;

    var track = mediaWrapper.querySelector('[data-lhc-carousel-track]');
    if (!track || !track.children.length) return;

    var count = track.children.length;
    if (count <= 1) return;

    var width = Math.max(track.clientWidth, 1);
    var currentIndex = clamp(Math.round(track.scrollLeft / width), 0, count - 1);
    var step = direction < 0 ? -1 : 1;
    var behavior = isReducedMotion() ? 'auto' : 'smooth';
    var card = mediaWrapper.closest(CARD_SELECTOR);
    var preview = mediaWrapper.querySelector('[data-lhc-hover-preview]');
    var previewWasVisible = step > 0 && currentIndex === 0 && this.isHoverPreviewVisible(mediaWrapper);
    var instance = this;

    if (card) card.setAttribute('data-lhc-hover-suppressed', 'true');

    if (previewWasVisible && preview) {
      preview.classList.remove('is-releasing');
      preview.classList.add('is-committing');

      var targetAfterPreview = Math.min(2, count - 1);
      var priorSnapType = track.style.scrollSnapType;
      var priorBehavior = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = targetAfterPreview * width;
      void track.offsetWidth;
      this.updateCarousel(mediaWrapper);
      track.style.scrollSnapType = priorSnapType;
      track.style.scrollBehavior = priorBehavior;

      window.requestAnimationFrame(function () {
        preview.classList.remove('is-committing');
        preview.classList.add('is-releasing');
        window.setTimeout(function () {
          preview.classList.remove('is-releasing');
          instance.updateCarousel(mediaWrapper);
        }, 170);
      });
      return;
    }

    var targetIndex = clamp(currentIndex + step, 0, count - 1);
    if (targetIndex === currentIndex) return;

    track.scrollTo({ left: targetIndex * width, behavior: behavior });
    if (behavior === 'auto') this.updateCarousel(mediaWrapper);
  };

  LohnrCollection.prototype.scrollGalleryToColor = function (card, colorName) {
    var track = card.querySelector('[data-lhc-carousel-track]');
    var mediaWrapper = card.querySelector('[data-lhc-media]');
    if (!track || !mediaWrapper) return false;

    var slides = toArray(track.children);
    var index = slides.findIndex(function (slide) {
      return String(slide.getAttribute('data-lhc-media-color') || '') === String(colorName);
    });
    if (index < 0) return false;

    track.scrollTo({
      left: index * Math.max(track.clientWidth, 1),
      behavior: 'auto'
    });
    this.updateCarousel(mediaWrapper, { skipColorSync: true });
    return true;
  };

  LohnrCollection.prototype.selectColor = function (card, colorName, announce, options) {
    if (!card) return null;

    var settings = options || {};
    var normalizedColor = String(colorName || '');
    var selectedColor = card.querySelector('[data-lhc-selected-color]');

    toArray(card.querySelectorAll('[data-lhc-swatch]')).forEach(function (item) {
      item.setAttribute('aria-pressed', (item.getAttribute('data-lhc-color') || '') === normalizedColor ? 'true' : 'false');
    });

    if (selectedColor) selectedColor.textContent = normalizedColor;

    var representativeVariant = this.getRepresentativeVariant(card, normalizedColor);
    if (!representativeVariant) return null;

    this.updateCardLinks(card, representativeVariant.id);
    this.updateCardPrice(card, representativeVariant);
    this.updateCardBadge(card, representativeVariant);
    this.updateCardAction(card, representativeVariant);

    if (!settings.skipMedia) {
      if (this.galleryColorMode() === 'all_sync') {
        var track = card.querySelector('[data-lhc-carousel-track]');
        var expectedCount = (card._lhcMedia || []).length;
        if (!track || track.children.length !== expectedCount) {
          this.renderMedia(card, normalizedColor, representativeVariant, { instant: true });
        } else {
          this.scrollGalleryToColor(card, normalizedColor);
        }
      } else {
        this.renderMedia(card, normalizedColor, representativeVariant);
      }
    }

    this.updateHoverPreview(card, normalizedColor);
    this.scheduleEditorialMeasurements();

    if (announce !== false) {
      this.setLiveMessage(normalizedColor + ' selected for ' + (card.getAttribute('data-lhc-product-title') || 'product') + '.');
    }

    return representativeVariant;
  };

  LohnrCollection.prototype.selectSwatch = function (swatch) {
    var card = swatch ? swatch.closest(CARD_SELECTOR) : null;
    if (!card) return;

    card.setAttribute('data-lhc-hover-suppressed', 'true');
    this.selectColor(card, swatch.getAttribute('data-lhc-color') || '', true);
  };

  LohnrCollection.prototype.revealSwatches = function (button) {
    var card = button.closest(CARD_SELECTOR);
    if (!card) return;

    var sizeIndex = this.getSizeIndex(card);
    var isComplex = card.getAttribute('data-lhc-complex') === 'true';
    if (sizeIndex >= 0 && !isComplex) {
      this.openQuickAdd(card, button);
      return;
    }

    var representativeVariant = this.getRepresentativeVariant(card, this.getSelectedColor(card));
    var productUrl = card.getAttribute('data-lhc-product-url') || '#';
    window.location.href = replaceUrlVariant(productUrl, representativeVariant ? representativeVariant.id : null);
  };

  LohnrCollection.prototype.warmSwatch = function (swatch) {
    if (!isHoverDevice()) return;

    var card = swatch.closest(CARD_SELECTOR);
    if (!card) return;

    var colorName = swatch.getAttribute('data-lhc-color') || '';
    if (card._lhcWarmColors.has(colorName)) return;
    card._lhcWarmColors.add(colorName);

    var first = this.mediaForColor(card, colorName)[0];
    if (!first || !first.u) return;

    var image = new Image();
    if (first.s) image.srcset = first.s;
    image.sizes = this.imageSizes(this.root.getAttribute('data-grid-density') || 'compact');
    image.src = first.u;
  };

  LohnrCollection.prototype.initializeQuickGallery = function () {
    if (!this.quickGalleryTrack || !this.quickGallery) return;

    var instance = this;
    var ticking = false;
    this.listen(
      this.quickGalleryTrack,
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          instance.updateQuickGallery();
          ticking = false;
        });
      },
      { passive: true }
    );
  };

  LohnrCollection.prototype.updateQuickGallery = function () {
    if (!this.quickGallery || !this.quickGalleryTrack) return;

    var count = Math.max(1, this.quickGalleryTrack.children.length);
    var index = count > 1 ? Math.round(this.quickGalleryTrack.scrollLeft / Math.max(this.quickGalleryTrack.clientWidth, 1)) : 0;
    index = clamp(index, 0, count - 1);

    this.quickGallery.setAttribute('data-slide-count', String(count));
    if (this.quickGalleryCurrent) this.quickGalleryCurrent.textContent = String(index + 1);
    if (this.quickGalleryTotal) this.quickGalleryTotal.textContent = String(count);
    if (this.quickGalleryPrevious) this.quickGalleryPrevious.disabled = count <= 1 || index === 0;
    if (this.quickGalleryNext) this.quickGalleryNext.disabled = count <= 1 || index >= count - 1;
    if (this.quickGalleryProgressBar) {
      this.quickGalleryProgressBar.style.width = String(100 / count) + '%';
      this.quickGalleryProgressBar.style.transform = 'translateX(' + String(index * 100) + '%)';
    }
  };

  LohnrCollection.prototype.renderQuickGallery = function (card, colorName) {
    if (!this.quickGalleryTrack || !this.quickGallery) return;

    var items = this.mediaForColor(card, colorName);
    if (!items.length) items = mediaFromRenderedSlides(card);
    this.quickGalleryTrack.textContent = '';
    var title = card.getAttribute('data-lhc-product-title') || '';
    var mobileGalleryWidth = window.getComputedStyle(this.root).getPropertyValue('--lhc-quick-mobile-width').trim() || '80vw';

    items.forEach(function (item, index) {
      var slide = document.createElement('div');
      slide.className = 'lhc-quick-gallery-slide';
      slide.setAttribute('data-lhc-quick-media-color', String(item.c || ''));
      slide.appendChild(createMediaImage(item, {
        sizes: '(max-width: 749px) ' + mobileGalleryWidth + ', 340px',
        alt: title,
        eager: index === 0
      }));
      this.quickGalleryTrack.appendChild(slide);
    }, this);

    if (!items.length) {
      var empty = document.createElement('div');
      empty.className = 'lhc-quick-gallery-empty';
      empty.textContent = 'Product imagery is unavailable.';
      this.quickGalleryTrack.appendChild(empty);
    }

    this.quickGalleryTrack.scrollLeft = 0;
    this.updateQuickGallery();
  };

  LohnrCollection.prototype.renderQuickSwatches = function (card, colorName) {
    if (!this.quickSwatches) return;

    var colors = Array.isArray(card._lhcColors) ? card._lhcColors.slice() : [];
    if (!colors.length) {
      colors = toArray(card.querySelectorAll('[data-lhc-swatch]')).map(function (source) {
        return {
          n: source.getAttribute('data-lhc-color') || '',
          a: !source.classList.contains('is-sold-out'),
          h: source.getAttribute('data-lhc-swatch-alt') || '',
          c: source.getAttribute('data-lhc-swatch-color') || ''
        };
      });
    }

    this.quickSwatches.textContent = '';
    if (this.quickColorGroup) this.quickColorGroup.hidden = colors.length === 0;
    if (!colors.length) return;

    var instance = this;
    colors.forEach(function (item) {
      var button = document.createElement('button');
      var chip = document.createElement('span');
      var colorNameValue = String(item.n || '');
      var altColor = extractHexColor(item.h);
      var storedColor = String(item.c || '').trim();
      var resolvedColor = altColor || (isUsableCssColor(storedColor) ? storedColor : fallbackColorForName(colorNameValue));

      button.type = 'button';
      button.className = 'lhc-quick-swatch' + (!item.a ? ' is-sold-out' : '');
      button.setAttribute('data-lhc-quick-swatch', '');
      button.setAttribute('data-lhc-color', colorNameValue);
      button.setAttribute('aria-label', colorNameValue + (!item.a ? ', sold out' : ''));
      button.setAttribute('aria-pressed', String(colorNameValue === colorName));
      button.setAttribute('data-lhc-swatch-color', resolvedColor);
      button.style.setProperty('--lhc-swatch-color', resolvedColor);

      chip.className = 'lhc-quick-swatch-chip';
      chip.setAttribute('aria-hidden', 'true');
      button.appendChild(chip);
      instance.quickSwatches.appendChild(button);
    });
  };

  LohnrCollection.prototype.selectQuickSize = function (button) {
    if (!button || button.disabled || !this.activeQuickCard) return;

    var variantId = parseInt(button.getAttribute('data-lhc-variant-id'), 10);
    var variants = this.activeQuickCard._lhcVariants || [];
    var variant = variants.find(function (item) {
      return Number(item.id) === Number(variantId);
    });
    if (!variant) return;

    toArray(this.quickSizes.querySelectorAll('[data-lhc-quick-size]')).forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });

    this.quickSelectedVariant = variant;
    if (this.quickSizeLabel) this.quickSizeLabel.textContent = button.textContent.trim();
    if (this.quickAddButton) {
      this.quickAddButton.disabled = !variant.a;
      this.quickAddButton.setAttribute('data-lhc-variant-id', String(variant.id));
      var label = this.quickAddButton.querySelector('[data-lhc-action-label]');
      if (label) label.textContent = variant.a ? 'Add to bag - ' + variant.pf : 'Sold out';
    }
    this.renderPrice(this.quickPrice, variant);
    if (this.quickProductLink) this.quickProductLink.href = replaceUrlVariant(this.quickProductLink.href, variant.id);
  };

  LohnrCollection.prototype.renderQuickSizes = function (card, colorName) {
    if (!this.quickSizes || !this.quickAddButton) return;

    var sizeIndex = this.getSizeIndex(card);
    var variants = this.getVariantsForColor(card, colorName);
    var sizeVariants = uniqueBy(variants, function (variant) {
      return sizeIndex >= 0 ? variant.o[sizeIndex] : variant.id;
    });

    this.quickSizes.textContent = '';
    this.quickSelectedVariant = null;
    this.quickAddButton.disabled = true;
    this.quickAddButton.removeAttribute('data-lhc-variant-id');
    var addLabel = this.quickAddButton.querySelector('[data-lhc-action-label]');
    if (addLabel) addLabel.textContent = sizeIndex >= 0 ? 'Select a size' : 'Add to bag';
    if (this.quickSizeLabel) this.quickSizeLabel.textContent = '';

    var instance = this;
    sizeVariants.forEach(function (variant) {
      var button = document.createElement('button');
      var sizeName = sizeIndex >= 0 ? variant.o[sizeIndex] : 'One size';
      button.type = 'button';
      button.className = 'lhc-size-button';
      button.setAttribute('data-lhc-quick-size', '');
      button.setAttribute('data-lhc-variant-id', String(variant.id));
      button.setAttribute('aria-pressed', 'false');
      button.textContent = sizeName;
      button.disabled = !variant.a;
      if (!variant.a) button.setAttribute('aria-label', sizeName + ', sold out');
      instance.quickSizes.appendChild(button);
    });

    var available = toArray(this.quickSizes.querySelectorAll('[data-lhc-quick-size]:not(:disabled)'));
    if (available.length === 1) this.selectQuickSize(available[0]);
  };

  LohnrCollection.prototype.renderQuickDrawer = function (card, colorName) {
    if (!card) return;

    var representativeVariant = this.getRepresentativeVariant(card, colorName);
    var productUrl = card.getAttribute('data-lhc-product-url') || '#';

    if (this.quickTitle) this.quickTitle.textContent = card.getAttribute('data-lhc-product-title') || 'Choose an option';
    if (this.quickColor) this.quickColor.textContent = colorName;
    if (this.quickStatus) this.quickStatus.textContent = '';
    if (this.quickProductLink) this.quickProductLink.href = replaceUrlVariant(productUrl, representativeVariant ? representativeVariant.id : null);

    this.renderQuickGallery(card, colorName);
    this.renderPrice(this.quickPrice, representativeVariant);
    this.renderQuickSwatches(card, colorName);
    this.renderQuickSizes(card, colorName);
  };

  LohnrCollection.prototype.openQuickAdd = function (card, trigger) {
    if (!this.quickDialog || !this.quickSizes || !this.quickAddButton) return;

    var sizeIndex = this.getSizeIndex(card);
    if (sizeIndex < 0) return;

    this.activeQuickCard = card;
    this.quickTrigger = trigger;
    this.renderQuickDrawer(card, this.getSelectedColor(card));
    if (!openDialog(this.quickDialog)) {
      this.activeQuickCard = null;
      this.quickTrigger = null;
      return;
    }

    var instance = this;
    window.requestAnimationFrame(function () {
      var firstAvailable = instance.quickSizes.querySelector('[data-lhc-quick-size]:not(:disabled)');
      if (firstAvailable) firstAvailable.focus({ preventScroll: true });
    });
  };

  LohnrCollection.prototype.handleCardAction = function (action) {
    var card = action.closest(CARD_SELECTOR);
    if (!card || action.tagName === 'A') return;

    var sizeIndex = this.getSizeIndex(card);
    if (sizeIndex >= 0) {
      this.openQuickAdd(card, action);
      return;
    }

    var variantId = parseInt(action.getAttribute('data-lhc-variant-id'), 10);
    if (variantId) this.addVariant(variantId, action, card);
  };

  /*
    Shrine 1.5.4 cart bridge.

    Shrine uses a Dawn-style <cart-drawer>, but the empty -> non-empty transition
    can remain stale when an external quick-add only sends the initial /cart/add.js
    response into renderContents(). After the add succeeds, force a no-op
    /cart/update.js section render, then give Shrine the freshly rendered drawer.
    If the drawer still has no line item, hydrate cart-drawer-items from the live
    main-cart-items section before opening it.
  */
  LohnrCollection.prototype.themeCart = function () {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  };

  LohnrCollection.prototype.setAddingState = function (trigger, isAdding, success) {
    if (!trigger) return;

    var label = trigger.querySelector('[data-lhc-action-label]');
    var labelTarget = label || trigger;

    if (isAdding) {
      if (!trigger.hasAttribute('data-lhc-original-label')) {
        trigger.setAttribute('data-lhc-original-label', labelTarget.textContent || '');
      }
      trigger.setAttribute('aria-busy', 'true');
      trigger.disabled = true;
      labelTarget.textContent = 'Adding...';
      return;
    }

    trigger.removeAttribute('aria-busy');
    var original = trigger.getAttribute('data-lhc-original-label') || '';
    labelTarget.textContent = success ? 'Added' : original;

    window.setTimeout(function () {
      if (!trigger.isConnected) return;
      labelTarget.textContent = original;
      trigger.disabled = false;
      trigger.removeAttribute('data-lhc-original-label');
    }, success ? 1500 : 300);
  };

  LohnrCollection.prototype.postShrineCartRefresh = function () {
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        updates: {},
        sections: 'cart-drawer,cart-icon-bubble,cart-notification-product,cart-notification-button',
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Cart refresh failed.');
        return data;
      });
    });
  };

  LohnrCollection.prototype.hydrateShrineDrawerItems = function (drawer) {
    if (!drawer) return Promise.resolve(false);

    var target = drawer.querySelector('cart-drawer-items') || document.querySelector('cart-drawer-items');
    if (!target) return Promise.resolve(false);

    var existingLine = target.querySelector('.cart-item, [data-cart-item], [data-line-item], tr.cart-item');
    if (existingLine) return Promise.resolve(true);

    return fetch(cartPageUrl() + '?section_id=main-cart-items', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        if (!response.ok) return false;
        return response.text();
      })
      .then(function (htmlText) {
        if (!htmlText) return false;
        var parsed = new DOMParser().parseFromString(htmlText, 'text/html');
        var source = parsed.querySelector('cart-items');
        if (!source) return false;
        target.innerHTML = source.innerHTML;
        return true;
      })
      .catch(function () { return false; });
  };

  LohnrCollection.prototype.renderShrineCart = function (data, trigger) {
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var instance = this;

    if (drawer && typeof drawer.setActiveElement === 'function') {
      drawer.setActiveElement(trigger);
    }

    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);

      return this.hydrateShrineDrawerItems(drawer).then(function () {
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') {
          window.setTimeout(function () { drawer.open(); }, 20);
        } else {
          drawer.classList.add('active', 'animate');
        }
        return true;
      });
    }

    if (notification && typeof notification.renderContents === 'function') {
      notification.classList.remove('is-empty');
      notification.renderContents(data);
      if (typeof notification.open === 'function') notification.open();
      return Promise.resolve(true);
    }

    var cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart, [data-cart-icon], [data-lah3-cart], .site-header__cart');
    if (cartIcon) cartIcon.click();
    return Promise.resolve(false);
  };

  LohnrCollection.prototype.addVariant = function (variantId, trigger, card) {
    if (this.isAdding || !variantId || !trigger || trigger.disabled) return;

    this.isAdding = true;
    this.setAddingState(trigger, true, false);
    if (this.quickStatus) this.quickStatus.textContent = 'Adding to your bag...';

    var instance = this;

    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.status || data.errors) {
            throw new Error(data.description || data.message || data.errors || 'This item could not be added.');
          }
          return data;
        });
      })
      .then(function (addData) {
        return instance.postShrineCartRefresh().then(function (freshData) {
          if (!freshData || !freshData.sections) freshData = addData;
          return instance.renderShrineCart(freshData, trigger).then(function () {
            return fetch(routeRoot() + 'cart.js', {
              method: 'GET',
              credentials: 'same-origin',
              cache: 'no-store',
              headers: { Accept: 'application/json' }
            }).then(function (response) {
              return response.ok ? response.json() : null;
            }).catch(function () { return null; }).then(function (cartSnapshot) {
              return { addData: addData, renderData: freshData, cart: cartSnapshot };
            });
          });
        });
      })
      .then(function (result) {
        instance.setAddingState(trigger, false, true);
        if (instance.quickStatus) instance.quickStatus.textContent = 'Added to your bag.';
        instance.setLiveMessage('Item added to your bag.');

        if (instance.quickDialog && instance.quickDialog.open) {
          instance.quickDialog.setAttribute('data-lhc-skip-focus-restore', 'true');
          window.setTimeout(function () { closeDialog(instance.quickDialog); }, 180);
        }

        var detail = {
          source: 'lohnr-collection-shrine',
          cart: result.cart,
          addData: result.addData,
          sections: result.renderData && result.renderData.sections ? result.renderData.sections : {}
        };

        ['cart:updated', 'cart:refresh', 'cart:change', 'cart-drawer:updated', 'theme:cart:change', 'ajaxProduct:added', 'product:added'].forEach(function (eventName) {
          document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: detail }));
        });
      })
      .catch(function (error) {
        instance.setAddingState(trigger, false, false);
        if (instance.quickStatus) instance.quickStatus.textContent = error.message || 'This item could not be added.';
        instance.setLiveMessage(error.message || 'This item could not be added.');
      })
      .finally(function () {
        instance.isAdding = false;
      });
  };

  LohnrCollection.prototype.renderCart = function (data, cart, trigger) {
    return this.renderShrineCart(data, trigger);
  };

  LohnrCollection.prototype.findEditorialReference = function (tile) {
    var sibling = tile.previousElementSibling;
    while (sibling) {
      if (sibling.matches && sibling.matches('.lhc-grid-item--product')) return sibling;
      sibling = sibling.previousElementSibling;
    }

    sibling = tile.nextElementSibling;
    while (sibling) {
      if (sibling.matches && sibling.matches('.lhc-grid-item--product')) return sibling;
      sibling = sibling.nextElementSibling;
    }

    return this.grid ? this.grid.querySelector('.lhc-grid-item--product') : null;
  };

  LohnrCollection.prototype.updateEditorialTileHeights = function () {
    var instance = this;
    toArray(this.root.querySelectorAll('[data-lhc-editorial-tile]')).forEach(function (tile) {
      var reference = instance.findEditorialReference(tile);
      if (!reference) return;

      var card = reference.querySelector(CARD_SELECTOR);
      var media = reference.querySelector('[data-lhc-media]');
      if (media) tile.style.setProperty('--lhc-editorial-product-media-height', Math.round(media.getBoundingClientRect().height) + 'px');
      if (card) tile.style.setProperty('--lhc-editorial-product-card-height', Math.round(card.getBoundingClientRect().height) + 'px');
    });
  };

  LohnrCollection.prototype.scheduleEditorialMeasurements = function () {
    if (this.editorialTicking) return;
    this.editorialTicking = true;
    var instance = this;
    window.requestAnimationFrame(function () {
      instance.updateEditorialTileHeights();
      instance.editorialTicking = false;
    });
  };

  LohnrCollection.prototype.initializeEditorialTiles = function () {
    var instance = this;
    this.scheduleEditorialMeasurements();
    this.listen(window, 'resize', function () {
      instance.scheduleEditorialMeasurements();
    }, { passive: true });

    toArray(this.root.querySelectorAll('.lhc-editorial-image')).forEach(function (image) {
      if (image.complete) return;
      instance.listen(image, 'load', function () { instance.scheduleEditorialMeasurements(); }, { once: true });
      instance.listen(image, 'error', function () { instance.scheduleEditorialMeasurements(); }, { once: true });
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (instance.root.isConnected) instance.scheduleEditorialMeasurements();
      });
    }
  };

  LohnrCollection.prototype.initializeRail = function () {
    var rail = this.root.querySelector('[data-lhc-rail]');
    var previous = this.root.querySelector('[data-lhc-rail-prev]');
    var next = this.root.querySelector('[data-lhc-rail-next]');
    if (!rail || !previous || !next) return;

    var update = function () {
      var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth - 2);
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= maxScroll;
    };

    this.listen(previous, 'click', function () {
      rail.scrollBy({ left: -rail.clientWidth * 0.82, behavior: isReducedMotion() ? 'auto' : 'smooth' });
    });

    this.listen(next, 'click', function () {
      rail.scrollBy({ left: rail.clientWidth * 0.82, behavior: isReducedMotion() ? 'auto' : 'smooth' });
    });

    var ticking = false;
    this.listen(
      rail,
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    this.listen(window, 'resize', update, { passive: true });
    update();

    var active = rail.querySelector('[aria-current="page"]');
    if (active) {
      window.requestAnimationFrame(function () {
        var desired = active.offsetLeft - Math.max(0, (rail.clientWidth - active.offsetWidth) / 2);
        rail.scrollTo({ left: Math.max(0, desired), behavior: 'auto' });
        update();
      });
    }
  };

  LohnrCollection.prototype.initializeCollectionMenu = function () {
    var shell = this.root.querySelector('[data-lhc-collection-menu]');
    var track = shell ? shell.querySelector('[data-lhc-menu-track]') : null;
    if (!shell || !track) return;

    var previous = shell.querySelector('[data-lhc-menu-prev]');
    var next = shell.querySelector('[data-lhc-menu-next]');
    var active = track.querySelector('[aria-current="page"]');

    function update() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      var hasOverflow = maxScroll > 2;
      var atStart = !hasOverflow || track.scrollLeft <= 2;
      var atEnd = !hasOverflow || track.scrollLeft >= maxScroll;
      shell.setAttribute('data-overflow', hasOverflow ? 'true' : 'false');
      shell.setAttribute('data-at-start', atStart ? 'true' : 'false');
      shell.setAttribute('data-at-end', atEnd ? 'true' : 'false');
      if (previous) previous.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    function centerActive(force) {
      if (!active) return;

      var trackRect = track.getBoundingClientRect();
      var activeRect = active.getBoundingClientRect();
      var isVisible = activeRect.left >= trackRect.left + 1 && activeRect.right <= trackRect.right - 1;
      if (!force && isVisible) return;

      var desired = active.offsetLeft - Math.max(0, (track.clientWidth - active.offsetWidth) / 2);
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      track.scrollTo({ left: clamp(desired, 0, maxScroll), behavior: 'auto' });
    }

    if (previous) {
      this.listen(previous, 'click', function () {
        track.scrollBy({ left: -Math.max(track.clientWidth * 0.72, 240), behavior: isReducedMotion() ? 'auto' : 'smooth' });
      });
    }

    if (next) {
      this.listen(next, 'click', function () {
        track.scrollBy({ left: Math.max(track.clientWidth * 0.72, 240), behavior: isReducedMotion() ? 'auto' : 'smooth' });
      });
    }

    var ticking = false;
    this.listen(
      track,
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    this.listen(
      window,
      'resize',
      function () {
        window.requestAnimationFrame(function () {
          update();
          centerActive(false);
          update();
        });
      },
      { passive: true }
    );

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(function () {
        update();
        centerActive(false);
      });
      resizeObserver.observe(track);
      this.cleanupCallbacks.push(function () {
        resizeObserver.disconnect();
      });
    }

    window.requestAnimationFrame(function () {
      update();
      centerActive(true);
      update();
    });
  };

  LohnrCollection.prototype.initializeDensity = function () {
    var stored = null;
    try {
      stored = window.localStorage.getItem('lohnr:editorial-collection-v7-density');
    } catch (error) {}

    this.setDensity(stored === 'large' ? 'large' : this.root.getAttribute('data-grid-density') || 'compact', false);
  };

  LohnrCollection.prototype.setDensity = function (density, persist) {
    var normalized = density === 'large' ? 'large' : 'compact';
    this.root.setAttribute('data-grid-density', normalized);

    toArray(this.root.querySelectorAll('[data-lhc-density]')).forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-lhc-density') === normalized ? 'true' : 'false');
    });

    this.updateImageSizes();
    this.scheduleEditorialMeasurements();

    if (persist !== false) {
      try {
        window.localStorage.setItem('lohnr:editorial-collection-v7-density', normalized);
      } catch (error) {}
    }
  };

  LohnrCollection.prototype.initializeStickyOffset = function () {
    var instance = this;

    function update() {
      if (instance.stickyTicking) return;
      instance.stickyTicking = true;

      window.requestAnimationFrame(function () {
        var selectors = [
          'sticky-header',
          '#shopify-section-header',
          '.shopify-section-header-sticky',
          '[data-sticky-header]',
          '.site-header'
        ];
        var bottom = 0;

        selectors.forEach(function (selector) {
          toArray(document.querySelectorAll(selector)).forEach(function (element) {
            if (instance.root.contains(element)) return;

            var style = window.getComputedStyle(element);
            if (style.display === 'none' || style.visibility === 'hidden') return;
            if (style.position !== 'fixed' && style.position !== 'sticky') return;

            var rect = element.getBoundingClientRect();
            if (rect.height <= 0 || rect.bottom <= 0 || rect.top > 8) return;
            bottom = Math.max(bottom, rect.bottom);
          });
        });

        instance.root.style.setProperty('--lhc-sticky-top', Math.max(0, Math.round(bottom)) + 'px');
        instance.stickyTicking = false;
      });
    }

    update();
    this.listen(window, 'scroll', update, { passive: true });
    this.listen(window, 'resize', update, { passive: true });
  };

  LohnrCollection.prototype.initializeDialogs = function () {
    var instance = this;

    [this.filterDialog, this.quickDialog].forEach(function (dialog) {
      if (!dialog) return;

      instance.listen(dialog, 'close', function () {
        document.body.classList.remove(DIALOG_OPEN_CLASS);

        var skipRestore = dialog.getAttribute('data-lhc-skip-focus-restore') === 'true';
        dialog.removeAttribute('data-lhc-skip-focus-restore');
        var trigger = dialog === instance.quickDialog ? instance.quickTrigger : instance.filterTrigger;

        if (dialog === instance.quickDialog) {
          instance.activeQuickCard = null;
          instance.quickTrigger = null;
          instance.quickSelectedVariant = null;
          if (instance.quickStatus) instance.quickStatus.textContent = '';
          if (instance.quickAddButton) instance.quickAddButton.removeAttribute('data-lhc-variant-id');
        } else {
          instance.filterTrigger = null;
        }

        if (!skipRestore && trigger && trigger.isConnected) {
          window.requestAnimationFrame(function () {
            trigger.focus({ preventScroll: true });
          });
        }
      });

      instance.listen(dialog, 'click', function (event) {
        if (event.target === dialog) closeDialog(dialog);
      });
    });
  };

  LohnrCollection.prototype.initializeSorting = function () {
    var select = this.root.querySelector('[data-lhc-sort]');
    if (!select) return;

    var instance = this;
    this.listen(select, 'change', function () {
      var form = select.closest('form');
      if (!form) return;
      instance.navigateCollection(instance.formUrl(form), { history: 'push', focus: 'sort' });
    });
  };

  LohnrCollection.prototype.formUrl = function (form) {
    var target = new URL(form.action || window.location.href, window.location.href);
    target.search = '';

    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      if (typeof File !== 'undefined' && value instanceof File) return;
      var normalized = String(value == null ? '' : value).trim();
      if (normalized) target.searchParams.append(key, normalized);
    });

    return target.toString();
  };

  LohnrCollection.prototype.fetchCollectionHtml = function (url, signal) {
    var instance = this;
    var target = new URL(url, window.location.href);

    function request(requestUrl) {
      return fetch(requestUrl, {
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        signal: signal
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to update this collection.');
        return response.text();
      });
    }

    if (!this.sectionId) return request(target.href);

    var sectionUrl = new URL(target.href);
    sectionUrl.searchParams.set('section_id', this.sectionId);

    return request(sectionUrl.href).then(
      function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        return parsed.getElementById(instance.root.id) ? html : request(target.href);
      },
      function (error) {
        if (error && error.name === 'AbortError') throw error;
        return request(target.href);
      }
    );
  };

  LohnrCollection.prototype.setCollectionBusy = function (isBusy) {
    this.root.classList.toggle('is-updating', Boolean(isBusy));
    this.root.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  };

  LohnrCollection.prototype.focusUpdatedCollection = function (root, focusTarget) {
    if (!root || !focusTarget) return;

    var target = null;
    if (focusTarget === 'sort') {
      target = root.querySelector('[data-lhc-sort]');
    } else if (focusTarget === 'grid') {
      target = root.querySelector('[data-lhc-grid]');
    } else {
      target = root.querySelector('.lhc-result-count') || root.querySelector('[data-lhc-grid]');
    }

    if (target && target.getClientRects && target.getClientRects().length === 0) {
      target = root.querySelector('[data-lhc-grid]');
    }
    if (!target) return;
    var hadTabIndex = target.hasAttribute('tabindex');
    if (!hadTabIndex) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });

    if (!hadTabIndex) {
      target.addEventListener(
        'blur',
        function () {
          target.removeAttribute('tabindex');
        },
        { once: true }
      );
    }
  };

  LohnrCollection.prototype.navigateCollection = function (url, options) {
    var instance = this;
    var settings = options || {};
    var target;

    try {
      target = new URL(url, window.location.href);
    } catch (error) {
      window.location.assign(url);
      return Promise.resolve(false);
    }

    if (target.origin !== window.location.origin) {
      window.location.assign(target.href);
      return Promise.resolve(false);
    }

    if (this.collectionRequestController) this.collectionRequestController.abort();
    var requestController = typeof AbortController === 'function' ? new AbortController() : null;
    this.collectionRequestController = requestController;
    var requestId = ++this.collectionRequestId;
    var currentRoot = this.root;
    var currentAnchor = currentRoot.querySelector('.lhc-controls-shell');
    var anchorTop = currentAnchor ? currentAnchor.getBoundingClientRect().top : null;

    if (this.filterDialog && this.filterDialog.open) closeDialog(this.filterDialog);
    this.setCollectionBusy(true);

    return this.fetchCollectionHtml(target.href, requestController ? requestController.signal : undefined)
      .then(function (html) {
        if (requestId !== instance.collectionRequestId) return false;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var nextRoot = parsed.getElementById(currentRoot.id);
        if (!nextRoot) throw new Error('The updated collection section was not found.');

        instance.collectionRequestController = null;
        instance.destroy();
        currentRoot.replaceWith(nextRoot);

        if (settings.history !== 'none') {
          var method = settings.history === 'replace' ? 'replaceState' : 'pushState';
          window.history[method]({ lohnrCollection: true }, '', target.href);
        }

        if (parsed.title) document.title = parsed.title;
        initializeAll(nextRoot);

        var nextInstance = nextRoot._lhcInstance;
        if (nextInstance) nextInstance.setLiveMessage(settings.message || 'Collection updated.');

        document.body.classList.remove(DIALOG_OPEN_CLASS);

        window.requestAnimationFrame(function () {
          var nextAnchor = nextRoot.querySelector('.lhc-controls-shell');
          if (anchorTop !== null && nextAnchor && settings.preserveAnchor !== false) {
            var delta = nextAnchor.getBoundingClientRect().top - anchorTop;
            if (Math.abs(delta) > 1) window.scrollBy({ top: delta, behavior: 'auto' });
          }

          if (nextInstance) nextInstance.focusUpdatedCollection(nextRoot, settings.focus);
        });

        return true;
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return false;
        window.location.assign(target.href);
        return false;
      })
      .finally(function () {
        if (requestId === instance.collectionRequestId && currentRoot.isConnected) {
          instance.setCollectionBusy(false);
        }
      });
  };

  LohnrCollection.prototype.bindEvents = function () {
    var instance = this;

    this.listen(document, 'pointerdown', function () {
      instance.lastInputMethod = 'pointer';
      instance.root.removeAttribute('data-lhc-keyboard-mode');
    }, true);

    this.listen(document, 'keydown', function (event) {
      if (event.key === 'Tab' || event.key.indexOf('Arrow') === 0) {
        instance.lastInputMethod = 'keyboard';
        instance.root.setAttribute('data-lhc-keyboard-mode', 'true');
      }
    }, true);

    this.listen(this.root, 'submit', function (event) {
      var form = event.target;
      if (!form || !instance.root.contains(form)) return;
      if (!form.matches('.lhc-filter-form, .lhc-sort-form')) return;

      event.preventDefault();
      var focusTarget = form.classList.contains('lhc-sort-form') ? 'sort' : 'results';
      instance.navigateCollection(instance.formUrl(form), {
        history: 'push',
        focus: focusTarget,
        message: form.classList.contains('lhc-sort-form') ? 'Products sorted.' : 'Filters applied.'
      });
    });

    this.listen(this.root, 'click', function (event) {
      var filterOpen = event.target.closest('[data-lhc-open-filters]');
      if (filterOpen && instance.root.contains(filterOpen)) {
        event.preventDefault();
        instance.filterTrigger = filterOpen;
        if (!openDialog(instance.filterDialog)) instance.filterTrigger = null;
        return;
      }

      var closeButton = event.target.closest('[data-lhc-dialog-close]');
      if (closeButton && instance.root.contains(closeButton)) {
        event.preventDefault();
        closeDialog(closeButton.closest('dialog'));
        return;
      }

      var filterLink = event.target.closest('[data-lhc-filter-link]');
      if (
        filterLink &&
        instance.root.contains(filterLink) &&
        event.button === 0 &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey
      ) {
        event.preventDefault();
        instance.navigateCollection(filterLink.href, {
          history: 'push',
          focus: 'results',
          message: 'Filter removed.'
        });
        return;
      }

      var densityButton = event.target.closest('[data-lhc-density]');
      if (densityButton && instance.root.contains(densityButton)) {
        event.preventDefault();
        instance.setDensity(densityButton.getAttribute('data-lhc-density'));
        return;
      }

      var moreSwatches = event.target.closest('[data-lhc-swatch-more]');
      if (moreSwatches && instance.root.contains(moreSwatches)) {
        event.preventDefault();
        instance.revealSwatches(moreSwatches);
        return;
      }

      var swatch = event.target.closest('[data-lhc-swatch]');
      if (swatch && instance.root.contains(swatch)) {
        event.preventDefault();
        instance.selectSwatch(swatch);
        return;
      }

      var previous = event.target.closest('[data-lhc-carousel-prev]');
      var next = event.target.closest('[data-lhc-carousel-next]');
      if ((previous || next) && instance.root.contains(previous || next)) {
        event.preventDefault();
        var media = (previous || next).closest('[data-lhc-media]');
        instance.navigateCardGallery(media, previous ? -1 : 1);
        return;
      }

      var quickGalleryPrevious = event.target.closest('[data-lhc-quick-gallery-prev]');
      var quickGalleryNext = event.target.closest('[data-lhc-quick-gallery-next]');
      if ((quickGalleryPrevious || quickGalleryNext) && instance.root.contains(quickGalleryPrevious || quickGalleryNext)) {
        event.preventDefault();
        if (instance.quickGalleryTrack) {
          instance.quickGalleryTrack.scrollBy({
            left: (quickGalleryPrevious ? -1 : 1) * instance.quickGalleryTrack.clientWidth,
            behavior: isReducedMotion() ? 'auto' : 'smooth'
          });
        }
        return;
      }

      var cardAction = event.target.closest('[data-lhc-card-action]');
      if (cardAction && instance.root.contains(cardAction) && cardAction.tagName !== 'A') {
        event.preventDefault();
        instance.handleCardAction(cardAction);
        return;
      }

      var quickSwatch = event.target.closest('[data-lhc-quick-swatch]');
      if (quickSwatch && instance.root.contains(quickSwatch) && instance.activeQuickCard) {
        event.preventDefault();
        var colorName = quickSwatch.getAttribute('data-lhc-color') || '';
        instance.selectColor(instance.activeQuickCard, colorName, true);
        instance.renderQuickDrawer(instance.activeQuickCard, colorName);
        window.requestAnimationFrame(function () {
          var selectedQuickSwatch = instance.quickSwatches
            ? instance.quickSwatches.querySelector('[data-lhc-quick-swatch][aria-pressed="true"]')
            : null;
          if (selectedQuickSwatch) selectedQuickSwatch.focus({ preventScroll: true });
        });
        return;
      }

      var quickSize = event.target.closest('[data-lhc-quick-size]');
      if (quickSize && instance.root.contains(quickSize)) {
        event.preventDefault();
        instance.selectQuickSize(quickSize);
        return;
      }

      var quickAdd = event.target.closest('[data-lhc-quick-add]');
      if (quickAdd && instance.root.contains(quickAdd)) {
        event.preventDefault();
        var quickVariantId = parseInt(quickAdd.getAttribute('data-lhc-variant-id'), 10);
        if (quickVariantId) instance.addVariant(quickVariantId, quickAdd, instance.activeQuickCard);
        return;
      }

      var loadMore = event.target.closest('[data-lhc-load-more]');
      if (loadMore && instance.root.contains(loadMore)) {
        event.preventDefault();
        instance.loadMore(loadMore, { restore: false });
        return;
      }

      var productLink = event.target.closest('[data-lhc-product-link]');
      if (productLink && instance.root.contains(productLink)) {
        instance.saveState();
      }
    });

    this.listen(this.root, 'pointerover', function (event) {
      var swatch = event.target.closest('[data-lhc-swatch]');
      if (swatch && instance.root.contains(swatch)) instance.warmSwatch(swatch);
    });

    this.listen(this.root, 'focusin', function (event) {
      var swatch = event.target.closest('[data-lhc-swatch]');
      if (swatch && instance.root.contains(swatch)) instance.warmSwatch(swatch);
    });

    this.listen(window, 'pagehide', function () {
      instance.saveState();
    });

    this.listen(window, 'popstate', function () {
      instance.navigateCollection(window.location.href, {
        history: 'none',
        focus: false,
        message: 'Collection restored.'
      });
    });
  };

  LohnrCollection.prototype.fetchPage = function (url) {
    if (this.prefetchCache.has(url)) return this.prefetchCache.get(url);

    var promise = this.fetchCollectionHtml(url).catch(function () {
      throw new Error('Unable to load more products.');
    });

    this.prefetchCache.set(url, promise);
    return promise;
  };

  LohnrCollection.prototype.loadMore = function (link, options) {
    var instance = this;
    var settings = options || {};
    if (!link || link.classList.contains('is-loading') || !this.grid) return Promise.resolve(false);

    var url = link.href;
    var originalLabel = link.textContent;
    var shouldMoveFocus = document.activeElement === link && !settings.restore;
    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');
    link.textContent = link.getAttribute('data-lhc-loading-label') || 'Loading...';
    this.grid.setAttribute('aria-busy', 'true');

    return this.fetchPage(url)
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = parsed.getElementById(instance.grid.id);
        var nextRoot = parsed.getElementById(instance.root.id);
        var nextPagination = nextRoot ? nextRoot.querySelector('[data-lhc-pagination]') : null;

        if (!nextGrid) throw new Error('The next product grid was not found.');

        var appendedItems = toArray(nextGrid.children);
        appendedItems.forEach(function (item) {
          instance.grid.appendChild(item);
        });

        var firstNewProductLink = appendedItems.length
          ? appendedItems[0].querySelector('.lhc-product-link[data-lhc-product-link]') ||
            appendedItems[0].querySelector('[data-lhc-product-link]')
          : null;
        var currentPagination = instance.root.querySelector('[data-lhc-pagination]');
        if (currentPagination && nextPagination) {
          currentPagination.replaceWith(nextPagination);
        } else if (currentPagination) {
          currentPagination.remove();
        }

        instance.loadedPages += 1;
        instance.initializeCards(instance.grid);
        instance.scheduleEditorialMeasurements();
        instance.observeLoadMore();
        instance.grid.setAttribute('aria-busy', 'false');

        if (!settings.restore) {
          instance.setLiveMessage('More products loaded.');
          instance.saveState();
          if (shouldMoveFocus && firstNewProductLink) {
            firstNewProductLink.setAttribute('tabindex', '-1');
            firstNewProductLink.focus({ preventScroll: true });
            firstNewProductLink.addEventListener(
              'blur',
              function () {
                firstNewProductLink.removeAttribute('tabindex');
              },
              { once: true }
            );
          }
        }

        return true;
      })
      .catch(function (error) {
        if (settings.restore) return false;
        window.location.href = url;
        return false;
      })
      .finally(function () {
        instance.grid.setAttribute('aria-busy', 'false');
        if (link.isConnected) {
          link.classList.remove('is-loading');
          link.removeAttribute('aria-busy');
          link.textContent = originalLabel;
        }
      });
  };

  LohnrCollection.prototype.observeLoadMore = function () {
    var instance = this;
    var link = this.root.querySelector('[data-lhc-load-more]');
    if (!link) return;

    if (this.prefetchObserver) this.prefetchObserver.disconnect();
    if (!('IntersectionObserver' in window)) return;

    this.prefetchObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          instance.fetchPage(link.href).catch(function () {});
          instance.prefetchObserver.disconnect();
        });
      },
      { rootMargin: '700px 0px' }
    );

    this.prefetchObserver.observe(link);
  };

  LohnrCollection.prototype.saveState = function () {
    if (this.restoreInProgress) return;

    try {
      window.sessionStorage.setItem(
        this.stateKey,
        JSON.stringify({
          pages: this.loadedPages,
          scrollY: window.scrollY,
          timestamp: Date.now()
        })
      );
    } catch (error) {}
  };

  LohnrCollection.prototype.restoreState = function () {
    if (navigationType() !== 'back_forward') return;

    var state = null;
    try {
      state = JSON.parse(window.sessionStorage.getItem(this.stateKey) || 'null');
    } catch (error) {}

    if (!state || Date.now() - state.timestamp > STATE_MAX_AGE || state.pages <= 1) return;

    this.restoreInProgress = true;
    var previousScrollRestoration = null;
    if ('scrollRestoration' in history) {
      previousScrollRestoration = history.scrollRestoration;
      history.scrollRestoration = 'manual';
    }

    var instance = this;
    var targetPages = Math.max(1, parseInt(state.pages, 10) || 1);

    function loadNext() {
      if (instance.loadedPages >= targetPages) return Promise.resolve(true);
      var link = instance.root.querySelector('[data-lhc-load-more]');
      if (!link) return Promise.resolve(false);
      return instance.loadMore(link, { restore: true }).then(function (loaded) {
        return loaded ? loadNext() : false;
      });
    }

    loadNext().finally(function () {
      window.requestAnimationFrame(function () {
        window.scrollTo({ top: Math.max(0, state.scrollY || 0), behavior: 'auto' });
        instance.restoreInProgress = false;
        if (previousScrollRestoration !== null) history.scrollRestoration = previousScrollRestoration;
      });
    });
  };

  LohnrCollection.prototype.destroy = function () {
    if (this.prefetchObserver) this.prefetchObserver.disconnect();
    if (this.collectionRequestController) this.collectionRequestController.abort();
    if (this.eventController) this.eventController.abort();
    this.cleanupCallbacks.forEach(function (cleanup) {
      try {
        cleanup();
      } catch (error) {}
    });
    this.cleanupCallbacks = [];
    this.prefetchCache.clear();
    this.filterTrigger = null;
    this.quickTrigger = null;
    this.root.classList.remove('is-updating');
    this.root.removeAttribute('aria-busy');
    this.root.removeAttribute('data-lhc-initialized');
    document.body.classList.remove(DIALOG_OPEN_CLASS);
    delete this.root._lhcInstance;
  };

  LohnrCollection.prototype.setLiveMessage = function (message) {
    var live = this.root.querySelector('[data-lhc-live]');
    if (!live) return;

    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = message;
    }, 20);
  };

  function rootsWithin(scope) {
    var target = scope || document;
    var roots = toArray(target.querySelectorAll ? target.querySelectorAll(ROOT_SELECTOR) : []);
    if (target.matches && target.matches(ROOT_SELECTOR)) roots.unshift(target);
    return roots;
  }

  function initializeAll(scope) {
    rootsWithin(scope).forEach(function (root) {
      if (root._lhcInstance) return;
      var instance = new LohnrCollection(root);
      root._lhcInstance = instance;
      instance.init();
    });
  }

  ready(function () {
    initializeAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    rootsWithin(event.target).forEach(function (root) {
      if (root._lhcInstance && typeof root._lhcInstance.destroy === 'function') {
        root._lhcInstance.destroy();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lohnr-product-discovery-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var ROOT='[data-lpd2-module]', CARD='[data-lpd2-card]', BODY_CLASS='lpd2-dialog-open';
var FALLBACKS={black:'#111111',white:'#ffffff',ivory:'#f5f0e6',cream:'#f3ead8',beige:'#d6c3a5',tan:'#b58b62',brown:'#6f4e37',grey:'#8a8a86',gray:'#8a8a86',charcoal:'#3f4244',navy:'#18263d',blue:'#496d9b',green:'#566e55',olive:'#73754c',red:'#a93232',burgundy:'#6d2332',pink:'#d69aa8',purple:'#755985',orange:'#c97942',yellow:'#d6b95d'};
function ready(fn){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn,{once:true});}else{fn();}}
function arr(v){return Array.prototype.slice.call(v||[]);} function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
function json(el,f){if(!el)return f;try{return JSON.parse(el.textContent||'');}catch(e){return f;}}
function rootRoute(){return window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/';}
function cartUrl(){return window.routes&&window.routes.cart_add_url?window.routes.cart_add_url:rootRoute()+'cart/add.js';}
function reduced(){return !!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);} function hoverDevice(){return !!(window.matchMedia&&window.matchMedia('(hover: hover)').matches);}
function openDialog(d){if(!d)return false;document.body.classList.add(BODY_CLASS);try{if(typeof d.showModal==='function'){if(!d.open)d.showModal();}else{d.setAttribute('open','');}return true;}catch(e){document.body.classList.remove(BODY_CLASS);return false;}}
function closeDialog(d){if(!d)return;if(typeof d.close==='function'&&d.open)d.close();else{d.removeAttribute('open');document.body.classList.remove(BODY_CLASS);}}
function variantUrl(url,id){if(!url||!id)return url;try{var u=new URL(url,document.baseURI||location.href);u.searchParams.set('variant',String(id));return u.toString();}catch(e){return url;}}
function hex(v){var t=String(v||'').trim(),m=t.match(/#(?:[0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})(?![0-9a-f])/i);if(m)return m[0].toLowerCase();if(/^(?:[0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i.test(t))return'#'+t.toLowerCase();return'';}
function cssColor(v){return !!v&&(!window.CSS||!CSS.supports||CSS.supports('color',v));}
function fallback(name){var n=String(name||'').toLowerCase().replace(/[^a-z]+/g,' ').trim();if(FALLBACKS[n])return FALLBACKS[n];var ks=Object.keys(FALLBACKS);for(var i=0;i<ks.length;i++){if(n.split(' ').indexOf(ks[i])!==-1)return FALLBACKS[ks[i]];}return'#d8d8d4';}
function swatchColor(s){var a=hex(s.getAttribute('data-lpd2-swatch-alt'));if(a)return a;var c=String(s.getAttribute('data-lpd2-swatch-color')||'').trim();return cssColor(c)?c:fallback(s.getAttribute('data-lpd2-color'));}
function mediaTemplates(card){return arr(card.querySelectorAll('[data-lpd2-media-template]')).map(function(t){return{c:t.getAttribute('data-lpd2-media-color')||'',u:t.getAttribute('data-lpd2-media-src')||'',s:t.getAttribute('data-lpd2-media-srcset')||'',w:parseInt(t.getAttribute('data-lpd2-media-width'),10)||0,h:parseInt(t.getAttribute('data-lpd2-media-height'),10)||0,a:t.getAttribute('data-lpd2-media-alt')||''};}).filter(function(x){return !!x.u;});}
function mediaRendered(card){return arr(card.querySelectorAll('[data-lpd2-carousel-track] .lpd2-carousel-slide')).map(function(sl){var im=sl.querySelector('img');return im?{c:sl.getAttribute('data-lpd2-media-color')||'',u:im.currentSrc||im.src||'',s:im.srcset||'',w:im.naturalWidth||parseInt(im.width,10)||0,h:im.naturalHeight||parseInt(im.height,10)||0,a:im.alt||''}:null;}).filter(Boolean);}
function makeImage(item,opt){opt=opt||{};var im=document.createElement('img');im.src=item&&item.u?item.u:'';if(item&&item.s)im.srcset=item.s;if(opt.sizes)im.sizes=opt.sizes;im.alt=item&&item.a?item.a:(opt.alt||'');im.loading=opt.eager?'eager':'lazy';im.decoding='async';if(item&&item.w)im.width=item.w;if(item&&item.h)im.height=item.h;return im;}
function mergeFallbackProducts(slot,html,max,exclude){
  if(!slot||!html)return;
  var holder=document.createElement('template');holder.innerHTML=html;
  var source=holder.content.querySelector('[data-lpd2-product-list]'),target=slot.querySelector('[data-lpd2-product-list]');
  if(!source)return;
  if(!target){slot.innerHTML=html;return;}
  var seen=new Set(arr(target.querySelectorAll('[data-lpd2-card]')).map(function(card){return card.getAttribute('data-lpd2-product-id')||'';}));
  var count=target.querySelectorAll('[data-lpd2-product-item]').length;
  arr(source.querySelectorAll(':scope > [data-lpd2-product-item]')).some(function(item){
    if(max&&count>=max)return true;
    var card=item.querySelector('[data-lpd2-card]'),id=card&&card.getAttribute('data-lpd2-product-id');
    if(!id||seen.has(id)||(exclude&&exclude.has(id)))return false;
    seen.add(id);target.appendChild(item.cloneNode(true));count+=1;return false;
  });
}

function Discovery(root){this.root=root;this.sectionId=root.getAttribute('data-lpd2-section-id')||'';this.productId=root.getAttribute('data-lpd2-product-id')||'';this.quickDialog=root.querySelector('[data-lpd2-quick-dialog]');this.quickGallery=root.querySelector('[data-lpd2-quick-gallery]');this.quickTrack=root.querySelector('[data-lpd2-quick-gallery-track]');this.quickPrev=root.querySelector('[data-lpd2-quick-gallery-prev]');this.quickNext=root.querySelector('[data-lpd2-quick-gallery-next]');this.quickCurrent=root.querySelector('[data-lpd2-quick-gallery-current]');this.quickTotal=root.querySelector('[data-lpd2-quick-gallery-total]');this.quickProgress=root.querySelector('[data-lpd2-quick-gallery-progress-bar]');this.quickTitle=root.querySelector('[data-lpd2-quick-title]');this.quickPrice=root.querySelector('[data-lpd2-quick-price]');this.quickColor=root.querySelector('[data-lpd2-quick-color]');this.quickColorGroup=root.querySelector('[data-lpd2-quick-color-group]');this.quickSwatches=root.querySelector('[data-lpd2-quick-swatches]');this.quickSizes=root.querySelector('[data-lpd2-quick-sizes]');this.quickSizeLabel=root.querySelector('[data-lpd2-quick-size-label]');this.quickAdd=root.querySelector('[data-lpd2-quick-add]');this.quickLink=root.querySelector('[data-lpd2-quick-product-link]');this.quickStatus=root.querySelector('[data-lpd2-quick-status]');this.quickCard=null;this.quickTrigger=null;this.adding=false;this.keyboard=false;this.recommendationsLoaded=false;this.recommendationObserver=null;this.activeTab=0;this.listeners=[];}

Discovery.prototype.on=function(target,type,fn,opt){if(!target)return;target.addEventListener(type,fn,opt);this.listeners.push([target,type,fn,opt]);};

Discovery.prototype.init=function(){
  if(this.root.dataset.lpd2Ready==='true')return;
  this.root.dataset.lpd2Ready='true';
  this.initCards(this.root);
  this.bind();
  this.initQuickTrack();
  this.initCompleteRail();
  this.initTabs();
  this.preparePanels();
  this.deferRecommendations();
  this.updateInBag();
};


Discovery.prototype.initCards=function(scope){var self=this;arr(scope.querySelectorAll(CARD)).forEach(function(c){self.initCard(c);});};

Discovery.prototype.initCard=function(card){if(card.dataset.lpd2Ready==='true')return;card.dataset.lpd2Ready='true';card._variants=json(card.querySelector('[data-lpd2-variant-data]'),[]);card._media=mediaTemplates(card);if(!card._media.length)card._media=mediaRendered(card);card._colors=json(card.querySelector('[data-lpd2-color-data]'),[]);card._warm=new Set();arr(card.querySelectorAll('[data-lpd2-swatch]')).forEach(function(s){var c=swatchColor(s);s.setAttribute('data-lpd2-swatch-color',c);s.style.setProperty('--lpd2-swatch-color',c);});var media=card.querySelector('[data-lpd2-media]'),track=card.querySelector('[data-lpd2-carousel-track]'),self=this;if(track&&media){var tick=false;this.on(track,'scroll',function(){if(tick)return;tick=true;requestAnimationFrame(function(){self.updateCarousel(media);tick=false;});},{passive:true});this.updateCarousel(media);}this.on(card,'mouseenter',function(){card.removeAttribute('data-lpd2-hover-suppressed');});this.on(card,'mouseleave',function(){card.removeAttribute('data-lpd2-hover-suppressed');var p=card.querySelector('[data-lpd2-hover-preview]');if(p)p.classList.remove('is-committing','is-releasing');});var color=this.selectedColor(card),v=this.representative(card,color);if(v){this.updateLinks(card,v.id);this.renderPrice(card.querySelector('[data-lpd2-price]'),v);this.updateBadge(card,v);this.updateAction(card,v);this.updateHover(card,color);}};

Discovery.prototype.colorIndex=function(c){var v=parseInt(c.getAttribute('data-lpd2-color-index'),10);return Number.isNaN(v)?-1:v;};
Discovery.prototype.sizeIndex=function(c){var v=parseInt(c.getAttribute('data-lpd2-size-index'),10);return Number.isNaN(v)?-1:v;};
Discovery.prototype.selectedColor=function(c){var e=c.querySelector('[data-lpd2-selected-color]');return e?e.textContent.trim():'';};

Discovery.prototype.variantsFor=function(c,color){var vs=c._variants||[],i=this.colorIndex(c);return i<0?vs.slice():vs.filter(function(v){return String(v.o[i])===String(color);});};
Discovery.prototype.representative=function(c,color){var vs=this.variantsFor(c,color);return vs.find(function(v){return !!v.a;})||vs[0]||null;};

Discovery.prototype.mediaFor=function(c,color){var m=c._media||[],i=this.colorIndex(c),r=m.filter(function(x){return i<0||String(x.c)===String(color);});if(!r.length&&m.length){var f=m[0].c;r=m.filter(function(x){return String(x.c)===String(f);});}return r;};

Discovery.prototype.updateLinks=function(card,id){arr(card.querySelectorAll('[data-lpd2-product-link]')).forEach(function(a){a.href=variantUrl(a.href,id);});};

Discovery.prototype.renderPrice=function(el,v){if(!el||!v)return;el.textContent='';if(v.c&&v.c>v.p){var s=document.createElement('span');s.className='lpd2-price-sale';s.textContent=v.pf;var c=document.createElement('span');c.className='lpd2-price-compare';c.textContent=v.cf;el.append(s,c);}else{var r=document.createElement('span');r.className='lpd2-price-regular';r.textContent=v.pf;el.appendChild(r);}};

Discovery.prototype.updateBadge=function(card,v){var st=card.querySelector('[data-lpd2-badge-stack]'),b=card.querySelector('[data-lpd2-badge]');if(!st||!b)return;var av=this.variantsFor(card,this.selectedColor(card)).some(function(x){return !!x.a;}),txt=!av?'Sold out':(v&&v.c>v.p?'Sale':card.getAttribute('data-lpd2-tag-badge')||'');b.textContent=txt;b.classList.toggle('lpd2-badge--sale',txt==='Sale');st.hidden=!txt;};

Discovery.prototype.updateAction=function(card,v){var a=card.querySelector('[data-lpd2-card-action]'),l=a&&a.querySelector('[data-lpd2-action-label]');if(!a||!l)return;var complex=card.getAttribute('data-lpd2-complex')==='true',size=this.sizeIndex(card),title=card.getAttribute('data-lpd2-product-title')||'product',has=this.variantsFor(card,this.selectedColor(card)).some(function(x){return !!x.a;});if(complex){l.textContent='Select options';if(v)a.href=variantUrl(a.href,v.id);return;}if(a.tagName==='A')return;if(size>=0){l.textContent=has?'Quick add':'Sold out';a.disabled=!has;a.setAttribute('aria-label',has?'Quick add '+title:title+' sold out');}else{var can=!!(v&&v.a);l.textContent=can?'Add to bag':'Sold out';a.disabled=!can;if(v)a.setAttribute('data-lpd2-variant-id',String(v.id));}};

Discovery.prototype.imageSizes=function(){var m=this.root.getAttribute('data-lpd2-mobile-columns')||'2',d=this.root.getAttribute('data-lpd2-desktop-columns')||'4';return'(max-width: 749px) '+(100/Math.max(1,parseInt(m,10)))+'vw, '+(100/Math.max(1,parseInt(d,10)))+'vw';};

Discovery.prototype.updateHover=function(card,color){var old=card.querySelector('[data-lpd2-hover-preview]'),items=this.mediaFor(card,color);if(this.root.getAttribute('data-lpd2-hover-second-image')!=='true'||items.length<2){if(old)old.remove();return;}var p=old||document.createElement('div');p.className='lpd2-hover-preview';p.setAttribute('data-lpd2-hover-preview','');p.textContent='';p.appendChild(makeImage(items[1],{sizes:this.imageSizes(),alt:card.getAttribute('data-lpd2-product-title')||''}));if(!old){var media=card.querySelector('[data-lpd2-media]');if(media)media.appendChild(p);}};

Discovery.prototype.renderMedia=function(card,color,v){var media=card.querySelector('[data-lpd2-media]'),track=card.querySelector('[data-lpd2-carousel-track]'),items=this.mediaFor(card,color);if(!media||!track||!items.length)return;media.setAttribute('aria-busy','true');track.textContent='';var title=card.getAttribute('data-lpd2-product-title')||'',url=variantUrl(card.getAttribute('data-lpd2-product-url')||location.href,v&&v.id),sizes=this.imageSizes();items.forEach(function(item,i){var a=document.createElement('a');a.className='lpd2-carousel-slide';a.href=url;a.setAttribute('data-lpd2-product-link','');a.setAttribute('data-lpd2-media-color',item.c||'');a.setAttribute('aria-label','View '+title+(i?', image '+(i+1):''));a.appendChild(makeImage(item,{sizes:sizes,alt:title,eager:i===0}));track.appendChild(a);});track.scrollLeft=0;this.updateCarousel(media);var im=track.querySelector('img'),done=function(){media.removeAttribute('aria-busy');};if(im&&im.decode)im.decode().catch(function(){}).then(done);else done();};

Discovery.prototype.updateCarousel=function(media){if(!media)return;var track=media.querySelector('[data-lpd2-carousel-track]'),count=Math.max(1,track?track.children.length:0),idx=count>1?Math.round(track.scrollLeft/Math.max(track.clientWidth,1)):0;idx=clamp(idx,0,count-1);media.setAttribute('data-slide-count',String(count));media.setAttribute('data-active-slide',String(idx));var cur=media.querySelector('[data-lpd2-carousel-current]'),tot=media.querySelector('[data-lpd2-carousel-total]'),prev=media.querySelector('[data-lpd2-carousel-prev]'),next=media.querySelector('[data-lpd2-carousel-next]');if(cur)cur.textContent=String(idx+1);if(tot)tot.textContent=String(count);if(prev)prev.disabled=count<=1||idx===0;if(next)next.disabled=count<=1||idx>=count-1;};

Discovery.prototype.hoverVisible=function(media){if(!media||!hoverDevice()||this.root.getAttribute('data-lpd2-hover-second-image')!=='true'||media.getAttribute('data-active-slide')!=='0')return false;var card=media.closest(CARD),p=media.querySelector('[data-lpd2-hover-preview]');return !!(card&&p&&card.matches(':hover')&&card.getAttribute('data-lpd2-hover-suppressed')!=='true');};

Discovery.prototype.navigate=function(media,dir){var track=media&&media.querySelector('[data-lpd2-carousel-track]');if(!track||track.children.length<=1)return;var w=Math.max(track.clientWidth,1),count=track.children.length,idx=clamp(Math.round(track.scrollLeft/w),0,count-1),card=media.closest(CARD),preview=media.querySelector('[data-lpd2-hover-preview]'),hover=this.hoverVisible(media)&&dir>0&&idx===0,self=this;if(card)card.setAttribute('data-lpd2-hover-suppressed','true');if(hover&&preview){preview.classList.add('is-committing');var target=Math.min(2,count-1);track.scrollLeft=target*w;this.updateCarousel(media);requestAnimationFrame(function(){preview.classList.remove('is-committing');preview.classList.add('is-releasing');setTimeout(function(){preview.classList.remove('is-releasing');self.updateCarousel(media);},170);});return;}var target=clamp(idx+(dir<0?-1:1),0,count-1);track.scrollTo({left:target*w,behavior:reduced()?'auto':'smooth'});};

Discovery.prototype.selectColor=function(card,color,announce){arr(card.querySelectorAll('[data-lpd2-swatch]')).forEach(function(s){s.setAttribute('aria-pressed',String((s.getAttribute('data-lpd2-color')||'')===color));});var sc=card.querySelector('[data-lpd2-selected-color]');if(sc)sc.textContent=color;var v=this.representative(card,color);if(!v)return;card.setAttribute('data-lpd2-hover-suppressed','true');this.updateLinks(card,v.id);this.renderPrice(card.querySelector('[data-lpd2-price]'),v);this.updateBadge(card,v);this.updateAction(card,v);this.renderMedia(card,color,v);this.updateHover(card,color);if(announce!==false)this.live(color+' selected for '+(card.getAttribute('data-lpd2-product-title')||'product')+'.');return v;};

Discovery.prototype.warm=function(s){if(!hoverDevice())return;var c=s.closest(CARD),color=s.getAttribute('data-lpd2-color')||'';if(!c||c._warm.has(color))return;c._warm.add(color);var first=this.mediaFor(c,color)[0];if(!first)return;var im=new Image();if(first.s)im.srcset=first.s;im.sizes=this.imageSizes();im.src=first.u;};

Discovery.prototype.initQuickTrack=function(){var self=this;if(!this.quickTrack)return;var tick=false;this.on(this.quickTrack,'scroll',function(){if(tick)return;tick=true;requestAnimationFrame(function(){self.updateQuick();tick=false;});},{passive:true});};

Discovery.prototype.updateQuick=function(){if(!this.quickGallery||!this.quickTrack)return;var count=Math.max(1,this.quickTrack.children.length),idx=count>1?Math.round(this.quickTrack.scrollLeft/Math.max(this.quickTrack.clientWidth,1)):0;idx=clamp(idx,0,count-1);this.quickGallery.setAttribute('data-slide-count',String(count));if(this.quickCurrent)this.quickCurrent.textContent=String(idx+1);if(this.quickTotal)this.quickTotal.textContent=String(count);if(this.quickPrev)this.quickPrev.disabled=count<=1||idx===0;if(this.quickNext)this.quickNext.disabled=count<=1||idx>=count-1;if(this.quickProgress){this.quickProgress.style.width=String(100/count)+'%';this.quickProgress.style.transform='translateX('+String(idx*100)+'%)';}};

Discovery.prototype.renderQuickGallery=function(card,color){if(!this.quickTrack)return;var items=this.mediaFor(card,color);if(!items.length)items=mediaRendered(card);this.quickTrack.textContent='';var title=card.getAttribute('data-lpd2-product-title')||'',width=getComputedStyle(this.root).getPropertyValue('--lpd2-quick-mobile-width').trim()||'80vw';items.forEach(function(item,i){var s=document.createElement('div');s.className='lpd2-quick-gallery-slide';s.appendChild(makeImage(item,{sizes:'(max-width: 749px) '+width+', 340px',alt:title,eager:i===0}));this.quickTrack.appendChild(s);},this);if(!items.length){var e=document.createElement('div');e.className='lpd2-quick-gallery-empty';e.textContent='Product imagery is unavailable.';this.quickTrack.appendChild(e);}this.quickTrack.scrollLeft=0;this.updateQuick();};

Discovery.prototype.renderQuickSwatches=function(card,color){if(!this.quickSwatches)return;var colors=Array.isArray(card._colors)?card._colors:[];this.quickSwatches.textContent='';if(this.quickColorGroup)this.quickColorGroup.hidden=!colors.length;colors.forEach(function(x){var b=document.createElement('button'),chip=document.createElement('span'),name=String(x.n||''),resolved=hex(x.h)||(cssColor(String(x.c||''))?String(x.c):fallback(name));b.type='button';b.className='lpd2-quick-swatch'+(!x.a?' is-sold-out':'');b.setAttribute('data-lpd2-quick-swatch','');b.setAttribute('data-lpd2-color',name);b.setAttribute('aria-label',name+(!x.a?', sold out':''));b.setAttribute('aria-pressed',String(name===color));b.style.setProperty('--lpd2-swatch-color',resolved);chip.className='lpd2-quick-swatch-chip';b.appendChild(chip);this.quickSwatches.appendChild(b);},this);};

Discovery.prototype.selectSize=function(b){if(!b||b.disabled||!this.quickCard)return;var id=parseInt(b.getAttribute('data-lpd2-variant-id'),10),v=(this.quickCard._variants||[]).find(function(x){return x.id===id;});if(!v)return;arr(this.quickSizes.querySelectorAll('[data-lpd2-quick-size]')).forEach(function(x){x.setAttribute('aria-pressed',String(x===b));});this.quickSelected=v;if(this.quickSizeLabel)this.quickSizeLabel.textContent=b.textContent.trim();this.quickAdd.disabled=!v.a;this.quickAdd.setAttribute('data-lpd2-variant-id',String(v.id));this.renderPrice(this.quickPrice,v);if(this.quickLink)this.quickLink.href=variantUrl(this.quickLink.href,v.id);};

Discovery.prototype.renderQuickSizes=function(card,color){if(!this.quickSizes||!this.quickAdd)return;var vs=this.variantsFor(card,color),size=this.sizeIndex(card),self=this;this.quickSizes.textContent='';this.quickSelected=null;this.quickAdd.disabled=true;this.quickAdd.removeAttribute('data-lpd2-variant-id');if(this.quickSizeLabel)this.quickSizeLabel.textContent='';vs.forEach(function(v){var b=document.createElement('button');b.type='button';b.className='lpd2-size-button';b.setAttribute('data-lpd2-quick-size','');b.setAttribute('data-lpd2-variant-id',String(v.id));b.disabled=!v.a;b.textContent=size>=0?String(v.o[size]||'One size'):'One size';self.quickSizes.appendChild(b);});var first=this.quickSizes.querySelector('[data-lpd2-quick-size]:not(:disabled)');if(first)this.selectSize(first);};

Discovery.prototype.renderQuick=function(card,color){var v=this.representative(card,color),url=card.getAttribute('data-lpd2-product-url')||'#';if(this.quickTitle)this.quickTitle.textContent=card.getAttribute('data-lpd2-product-title')||'Choose an option';if(this.quickColor)this.quickColor.textContent=color;if(this.quickStatus)this.quickStatus.textContent='';if(this.quickLink)this.quickLink.href=variantUrl(url,v&&v.id);this.renderQuickGallery(card,color);this.renderPrice(this.quickPrice,v);this.renderQuickSwatches(card,color);this.renderQuickSizes(card,color);};

Discovery.prototype.openQuick=function(card,trigger){if(!this.quickDialog||this.sizeIndex(card)<0)return;this.quickCard=card;this.quickTrigger=trigger;this.renderQuick(card,this.selectedColor(card));if(!openDialog(this.quickDialog)){this.quickCard=null;return;}var self=this;requestAnimationFrame(function(){var f=self.quickSizes.querySelector('[data-lpd2-quick-size]:not(:disabled)');if(f)f.focus({preventScroll:true});});};

Discovery.prototype.handleAction=function(a){var c=a.closest(CARD);if(!c||a.tagName==='A')return;if(this.sizeIndex(c)>=0){this.openQuick(c,a);return;}var id=parseInt(a.getAttribute('data-lpd2-variant-id'),10);if(id)this.add(id,a,c);};

Discovery.prototype.themeCart=function(){return document.querySelector('cart-notification')||document.querySelector('cart-drawer');};
Discovery.prototype.cartSections=function(c){if(c&&typeof c.getSectionsToRender==='function')return c.getSectionsToRender().map(function(s){return s.id;}).filter(Boolean).slice(0,5);return['cart-drawer','cart-icon-bubble','cart-notification'];};

Discovery.prototype.addState=function(t,on,ok){if(!t)return;var l=t.querySelector('[data-lpd2-action-label]')||t;if(on){if(!t.hasAttribute('data-lpd2-original-label'))t.setAttribute('data-lpd2-original-label',l.textContent||'');t.setAttribute('aria-busy','true');t.disabled=true;l.textContent='Adding...';return;}t.removeAttribute('aria-busy');var orig=t.getAttribute('data-lpd2-original-label')||'';l.textContent=ok?'Added':orig;setTimeout(function(){l.textContent=orig;t.disabled=false;t.removeAttribute('data-lpd2-original-label');},ok?1500:300);};

Discovery.prototype.add=function(id,trigger,card){if(this.adding||!id||!trigger||trigger.disabled)return;this.adding=true;this.addState(trigger,true,false);if(this.quickStatus)this.quickStatus.textContent='Adding to your bag...';var cart=this.themeCart(),sections=this.cartSections(cart),fd=new FormData(),self=this;fd.append('id',String(id));fd.append('quantity','1');if(sections.length)fd.append('sections',sections.join(','));fd.append('sections_url',location.pathname);fetch(cartUrl(),{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:fd}).then(function(r){return r.json().then(function(d){if(!r.ok||d.status)throw new Error(d.description||d.message||'This item could not be added.');return d;});}).then(function(d){self.addState(trigger,false,true);if(self.quickStatus)self.quickStatus.textContent='Added to your bag.';self.live('Item added to your bag.');self.renderCart(d,cart,trigger);if(card){var badge=card.querySelector('[data-lpd2-in-bag]');if(badge)badge.hidden=false;}if(self.quickDialog&&self.quickDialog.open)setTimeout(function(){closeDialog(self.quickDialog);},240);document.documentElement.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:d}}));document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{cart:d}}));window.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart:d}}));}).catch(function(e){self.addState(trigger,false,false);if(self.quickStatus)self.quickStatus.textContent=e.message;self.live(e.message);}).finally(function(){self.adding=false;});};

Discovery.prototype.renderCart=function(data,cart,trigger){if(cart&&typeof cart.setActiveElement==='function')cart.setActiveElement(trigger);if(cart&&typeof cart.renderContents==='function'){cart.renderContents(data);return;}if(data.sections)Object.keys(data.sections).forEach(function(id){var html=data.sections[id],existing=document.getElementById('shopify-section-'+id)||document.getElementById(id);if(!html||!existing)return;var parsed=new DOMParser().parseFromString(html,'text/html'),replacement=parsed.getElementById(existing.id);if(replacement)existing.replaceWith(replacement);});var drawer=document.querySelector('cart-drawer'),notification=document.querySelector('cart-notification');if(drawer){drawer.classList.remove('is-empty');if(typeof drawer.open==='function')drawer.open();else drawer.classList.add('active','animate');}else if(notification&&typeof notification.open==='function')notification.open();else{var icon=document.querySelector('#cart-icon-bubble,.header__icon--cart,[data-cart-icon]');if(icon)icon.click();}};

Discovery.prototype.updateInBag=function(){if(this.root.getAttribute('data-lpd2-show-in-bag')!=='true')return;fetch(rootRoute()+'cart.js',{credentials:'same-origin'}).then(function(r){return r.ok?r.json():null;}).then(function(cart){if(!cart)return;var ids=new Set((cart.items||[]).map(function(i){return String(i.product_id);}));arr(this.root.querySelectorAll(CARD)).forEach(function(c){var b=c.querySelector('[data-lpd2-in-bag]');if(b)b.hidden=!ids.has(String(c.getAttribute('data-lpd2-product-id')));});}.bind(this)).catch(function(){});};

Discovery.prototype.loadRecommendations=function(){
  if(this.recommendationsLoaded)return Promise.resolve();
  this.recommendationsLoaded=true;
  if(this.recommendationObserver){this.recommendationObserver.disconnect();this.recommendationObserver=null;}
  var self=this,slots=arr(this.root.querySelectorAll('[data-lpd2-auto-slot]'));
  if(!slots.length){self.dedupe();self.preparePanels();self.cleanupEmpty();return Promise.resolve();}
  return Promise.allSettled(slots.map(function(s){return self.loadSlot(s);})).then(function(){
    self.dedupe();
    self.refillSlots(self.root);
    self.dedupe();
    self.preparePanels();
    self.cleanupEmpty();
    self.initCompleteRail();
    self.updateInBag();
    self.updateTabCounts();
  });
};


Discovery.prototype.loadSlot=function(slot){
  if(!slot)return Promise.resolve();
  if(slot.getAttribute('data-lpd2-loaded')==='true')return Promise.resolve();
  if(slot._lpd2Promise)return slot._lpd2Promise;
  var intent=slot.getAttribute('data-lpd2-intent')||'related',limit=slot.getAttribute('data-lpd2-limit')||'8',max=parseInt(slot.getAttribute('data-lpd2-max'),10)||parseInt(limit,10)||8,fallbackTemplate=slot.querySelector('[data-lpd2-auto-fallback]'),fallbackHTML=fallbackTemplate?fallbackTemplate.innerHTML:'',url=rootRoute()+'recommendations/products?product_id='+encodeURIComponent(this.productId)+'&limit='+encodeURIComponent(limit)+'&section_id='+encodeURIComponent(this.sectionId)+'&intent='+encodeURIComponent(intent),self=this;
  slot._lpd2FallbackHTML=fallbackHTML;slot._lpd2Max=max;
  slot.setAttribute('aria-busy','true');
  slot._lpd2Promise=fetch(url,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error('Recommendations unavailable');return r.text();}).then(function(text){
    var doc=new DOMParser().parseFromString(text,'text/html'),fragment=doc.querySelector('[data-lpd2-recommendation-fragment="'+intent+'"]'),has=fragment&&fragment.querySelector('[data-lpd2-card]');
    if(has){slot.innerHTML=fragment.innerHTML;if(fallbackHTML)mergeFallbackProducts(slot,fallbackHTML,max);}else if(fallbackHTML){slot.innerHTML=fallbackHTML;}else{slot.innerHTML='';}
  }).catch(function(){if(fallbackHTML)slot.innerHTML=fallbackHTML;else slot.innerHTML='';}).then(function(){
    slot.setAttribute('data-lpd2-loaded','true');slot.removeAttribute('aria-busy');slot._lpd2Promise=null;self.initCards(slot);
  });
  return slot._lpd2Promise;
};


Discovery.prototype.refillSlots=function(scope){
  var self=this,exclude=new Set(arr(this.root.querySelectorAll('[data-lpd2-group="complete"] '+CARD)).map(function(card){return card.getAttribute('data-lpd2-product-id')||'';}));
  arr((scope||this.root).querySelectorAll('[data-lpd2-auto-slot][data-lpd2-loaded="true"]')).forEach(function(slot){
    if((slot.getAttribute('data-lpd2-intent')||'')!=='related'||!slot._lpd2FallbackHTML)return;
    mergeFallbackProducts(slot,slot._lpd2FallbackHTML,slot._lpd2Max||0,exclude);self.initCards(slot);
  });
};

Discovery.prototype.dedupe=function(){
  var completeSeen=new Set(),completeIds=new Set();
  arr(this.root.querySelectorAll('[data-lpd2-group="complete"] '+CARD)).forEach(function(c){
    var id=c.getAttribute('data-lpd2-product-id'),item=c.closest('[data-lpd2-product-item]');
    if(!id||completeSeen.has(id)){if(item)item.remove();return;}
    completeSeen.add(id);completeIds.add(id);
  });
  arr(this.root.querySelectorAll('[data-lpd2-tab-panel]')).forEach(function(panel){
    var seen=new Set();
    arr(panel.querySelectorAll(CARD)).forEach(function(c){
      var id=c.getAttribute('data-lpd2-product-id'),item=c.closest('[data-lpd2-product-item]');
      if(!id||seen.has(id)||completeIds.has(id)){if(item)item.remove();return;}
      seen.add(id);
    });
  });
};


Discovery.prototype.applyRelatedLimit=function(){
  var self=this;
  arr(this.root.querySelectorAll('[data-lpd2-tab-panel]')).forEach(function(panel){self.applyPanelLimit(panel);});
};


Discovery.prototype.cleanupEmpty=function(){
  var look=this.root.querySelector('[data-lpd2-band="complete"]');
  if(look&&!look.querySelector(CARD)&&!look.querySelector('[data-lpd2-auto-slot]:not([data-lpd2-loaded="true"])'))look.hidden=true;
  var self=this,available=[];
  arr(this.root.querySelectorAll('[data-lpd2-tab-panel]')).forEach(function(panel){
    var slot=panel.querySelector('[data-lpd2-auto-slot]'),waiting=!!panel.querySelector(':scope > template[data-lpd2-panel-template]')||(slot&&!slot.hasAttribute('data-lpd2-loaded')),has=!!panel.querySelector(CARD),index=panel.getAttribute('data-lpd2-tab-index'),button=self.root.querySelector('[data-lpd2-tab-button="'+index+'"]');
    panel.setAttribute('data-lpd2-empty',has?'false':'true');if(button)button.hidden=!has&&!waiting;if(has||waiting)available.push(parseInt(index,10));
  });
  var explorer=this.root.querySelector('[data-lpd2-band="explorer"]');if(explorer)explorer.hidden=available.length===0;
  if(available.length&&available.indexOf(this.activeTab)===-1)this.activateTab(available[0],false);
};


Discovery.prototype.deferRecommendations=function(){
  var has=!!this.root.querySelector('[data-lpd2-auto-slot]');
  if(!has){this.dedupe();this.preparePanels();this.cleanupEmpty();return;}
  var lazy=this.root.getAttribute('data-lpd2-lazy-recommendations')==='true',design=this.root.getAttribute('data-lpd2-design-mode')==='true',self=this;
  if(!lazy||design||!('IntersectionObserver' in window)){this.loadRecommendations();return;}
  var margin=parseInt(this.root.getAttribute('data-lpd2-recommendation-margin'),10)||800;
  this.recommendationObserver=new IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting;}))self.loadRecommendations();},{rootMargin:margin+'px 0px'});
  this.recommendationObserver.observe(this.root);
};

Discovery.prototype.initTabs=function(){
  var self=this,buttons=arr(this.root.querySelectorAll('[data-lpd2-tab-button]'));
  if(!buttons.length)return;
  var selected=buttons.find(function(b){return b.getAttribute('aria-selected')==='true'&&!b.hidden;})||buttons.find(function(b){return !b.hidden;});
  if(selected)this.activateTab(parseInt(selected.getAttribute('data-lpd2-tab-button'),10),false,false);
  buttons.forEach(function(button,position){
    self.on(button,'click',function(){self.activateTab(parseInt(button.getAttribute('data-lpd2-tab-button'),10),true);});
    self.on(button,'keydown',function(e){
      if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft'&&e.key!=='Home'&&e.key!=='End')return;
      e.preventDefault();var visible=buttons.filter(function(b){return !b.hidden;}),current=visible.indexOf(button),next=current;
      if(e.key==='ArrowRight')next=(current+1)%visible.length;
      if(e.key==='ArrowLeft')next=(current-1+visible.length)%visible.length;
      if(e.key==='Home')next=0;if(e.key==='End')next=visible.length-1;
      visible[next].focus();self.activateTab(parseInt(visible[next].getAttribute('data-lpd2-tab-button'),10),true);
    });
  });
};

Discovery.prototype.activateTab=function(index,animate,loadNow){
  if(!index)return;this.activeTab=index;
  var self=this,target=this.root.querySelector('[data-lpd2-tab-panel][data-lpd2-tab-index="'+index+'"]');
  if(target)this.materializePanel(target);
  arr(this.root.querySelectorAll('[data-lpd2-tab-button]')).forEach(function(b){var active=parseInt(b.getAttribute('data-lpd2-tab-button'),10)===index;b.setAttribute('aria-selected',active?'true':'false');b.tabIndex=active?0:-1;if(active&&animate)b.scrollIntoView({block:'nearest',inline:'nearest',behavior:reduced()?'auto':'smooth'});});
  arr(this.root.querySelectorAll('[data-lpd2-tab-panel]')).forEach(function(panel){var active=parseInt(panel.getAttribute('data-lpd2-tab-index'),10)===index;panel.hidden=!active;panel.classList.remove('is-entering');if(active&&animate){void panel.offsetWidth;panel.classList.add('is-entering');arr(panel.querySelectorAll('[data-lpd2-media]')).forEach(function(media){self.updateCarousel(media);});}});
  if(target&&loadNow!==false)this.loadPanelRecommendations(target);
};

Discovery.prototype.panelGrid=function(panel){return panel?panel.querySelector('[data-lpd2-discovery-grid]'):null;};

Discovery.prototype.materializePanel=function(panel){
  if(!panel)return false;
  var template=panel.querySelector(':scope > template[data-lpd2-panel-template]');
  if(!template)return false;
  panel.appendChild(template.content.cloneNode(true));template.remove();
  this.initCards(panel);this.materializeEditorials(panel);this.positionEditorials(panel);this.applyPanelLimit(panel);this.updateTabCounts();
  return true;
};

Discovery.prototype.loadPanelRecommendations=function(panel){
  if(!panel)return Promise.resolve();
  var slots=arr(panel.querySelectorAll('[data-lpd2-auto-slot]:not([data-lpd2-loaded="true"])')),self=this;
  if(!slots.length)return Promise.resolve();
  panel.setAttribute('data-lpd2-panel-loading','true');
  return Promise.allSettled(slots.map(function(slot){return self.loadSlot(slot);})).then(function(){
    panel.removeAttribute('data-lpd2-panel-loading');self.dedupe();self.refillSlots(panel);self.dedupe();self.materializeEditorials(panel);self.positionEditorials(panel);self.applyPanelLimit(panel);self.cleanupEmpty();self.updateInBag();self.updateTabCounts();
  });
};

Discovery.prototype.materializeEditorials=function(panel){
  var grid=this.panelGrid(panel);if(!grid)return;
  arr(panel.querySelectorAll('template[data-lpd2-editorial-template]')).forEach(function(template){
    var id=template.getAttribute('data-lpd2-editorial-template');
    if(grid.querySelector('[data-lpd2-editorial-id="'+id+'"]'))return;
    var fragment=template.content.cloneNode(true);grid.appendChild(fragment);
  });
};

Discovery.prototype.positionEditorials=function(panel){
  var grid=this.panelGrid(panel);if(!grid)return;
  var products=arr(grid.querySelectorAll(':scope > [data-lpd2-product-item]'));
  arr(grid.querySelectorAll(':scope > [data-lpd2-editorial]')).sort(function(a,b){return(parseInt(a.getAttribute('data-lpd2-position'),10)||999)-(parseInt(b.getAttribute('data-lpd2-position'),10)||999);}).forEach(function(tile){
    var position=parseInt(tile.getAttribute('data-lpd2-position'),10)||products.length;
    if(position<=0)grid.insertBefore(tile,grid.firstChild);
    else if(position>=products.length)grid.appendChild(tile);
    else grid.insertBefore(tile,products[position]);
  });
};

Discovery.prototype.applyPanelLimit=function(panel){
  var grid=this.panelGrid(panel);if(!grid)return;
  var products=arr(grid.querySelectorAll(':scope > [data-lpd2-product-item]')),visible=parseInt(panel.getAttribute('data-lpd2-visible'),10)||products.length,shown=Math.min(visible,products.length);
  products.forEach(function(item,i){item.hidden=i>=shown;});
  arr(grid.querySelectorAll(':scope > [data-lpd2-editorial]')).forEach(function(tile){tile.hidden=(parseInt(tile.getAttribute('data-lpd2-position'),10)||1)>shown;});
  var wrap=panel.querySelector('[data-lpd2-load-more-wrap]');if(wrap)wrap.hidden=shown>=products.length;
  panel.setAttribute('data-lpd2-empty',products.length?'false':'true');
};

Discovery.prototype.preparePanels=function(){
  var self=this;
  arr(this.root.querySelectorAll('[data-lpd2-tab-panel]')).forEach(function(panel){self.materializeEditorials(panel);self.positionEditorials(panel);self.applyPanelLimit(panel);});
  this.updateTabCounts();
};

Discovery.prototype.updateTabCounts=function(){
  var self=this;
  arr(this.root.querySelectorAll('[data-lpd2-tab-panel]')).forEach(function(panel){var index=panel.getAttribute('data-lpd2-tab-index'),label=self.root.querySelector('[data-lpd2-tab-count="'+index+'"]');if(!label)return;if(panel.querySelector(':scope > template[data-lpd2-panel-template]')){label.textContent='';return;}label.textContent=String(panel.querySelectorAll(CARD).length);});
};

Discovery.prototype.initCompleteRail=function(){var list=this.root.querySelector('[data-lpd2-complete-list]'),prev=this.root.querySelector('[data-lpd2-complete-prev]'),next=this.root.querySelector('[data-lpd2-complete-next]');if(!list||!prev||!next)return;function update(){var max=Math.max(0,list.scrollWidth-list.clientWidth-2);prev.disabled=list.scrollLeft<=2;next.disabled=list.scrollLeft>=max;}if(list.dataset.lpdRailReady!=='true'){list.dataset.lpdRailReady='true';this.on(list,'scroll',update,{passive:true});this.on(prev,'click',function(){list.scrollBy({left:-list.clientWidth*.82,behavior:'smooth'});});this.on(next,'click',function(){list.scrollBy({left:list.clientWidth*.82,behavior:'smooth'});});}update();};

Discovery.prototype.bind=function(){var self=this;this.on(document,'pointerdown',function(){self.keyboard=false;self.root.removeAttribute('data-lpd2-keyboard-mode');},true);this.on(document,'keydown',function(e){if(e.key==='Tab'||e.key.indexOf('Arrow')===0){self.keyboard=true;self.root.setAttribute('data-lpd2-keyboard-mode','true');}},true);this.on(this.root,'click',function(e){var close=e.target.closest('[data-lpd2-dialog-close]');if(close){e.preventDefault();closeDialog(close.closest('dialog'));return;}var more=e.target.closest('[data-lpd2-swatch-more]');if(more){e.preventDefault();var c=more.closest(CARD);if(c&&self.sizeIndex(c)>=0&&c.getAttribute('data-lpd2-complex')!=='true')self.openQuick(c,more);else if(c)location.href=variantUrl(c.getAttribute('data-lpd2-product-url'),(self.representative(c,self.selectedColor(c))||{}).id);return;}var sw=e.target.closest('[data-lpd2-swatch]');if(sw){e.preventDefault();self.selectColor(sw.closest(CARD),sw.getAttribute('data-lpd2-color')||'',true);return;}var prev=e.target.closest('[data-lpd2-carousel-prev]'),next=e.target.closest('[data-lpd2-carousel-next]');if(prev||next){e.preventDefault();self.navigate((prev||next).closest('[data-lpd2-media]'),prev?-1:1);return;}var qprev=e.target.closest('[data-lpd2-quick-gallery-prev]'),qnext=e.target.closest('[data-lpd2-quick-gallery-next]');if(qprev||qnext){e.preventDefault();self.quickTrack.scrollBy({left:(qprev?-1:1)*self.quickTrack.clientWidth,behavior:reduced()?'auto':'smooth'});return;}var action=e.target.closest('[data-lpd2-card-action]');if(action&&action.tagName!=='A'){e.preventDefault();self.handleAction(action);return;}var qsw=e.target.closest('[data-lpd2-quick-swatch]');if(qsw&&self.quickCard){e.preventDefault();var color=qsw.getAttribute('data-lpd2-color')||'';self.selectColor(self.quickCard,color,true);self.renderQuick(self.quickCard,color);return;}var size=e.target.closest('[data-lpd2-quick-size]');if(size){e.preventDefault();self.selectSize(size);return;}var add=e.target.closest('[data-lpd2-quick-add]');if(add){e.preventDefault();var id=parseInt(add.getAttribute('data-lpd2-variant-id'),10);if(id)self.add(id,add,self.quickCard);return;}var load=e.target.closest('[data-lpd2-load-more]');if(load){e.preventDefault();var panel=load.closest('[data-lpd2-tab-panel]');if(panel){var visible=parseInt(panel.getAttribute('data-lpd2-visible'),10)||0,increment=parseInt(panel.getAttribute('data-lpd2-increment'),10)||4;panel.setAttribute('data-lpd2-visible',String(visible+increment));self.applyPanelLimit(panel);}return;}});this.on(this.root,'pointerover',function(e){var s=e.target.closest('[data-lpd2-swatch]');if(s)self.warm(s);});this.on(document,'shopify:block:select',function(e){var panel=e.target&&e.target.closest?e.target.closest('[data-lpd2-tab-panel]'):null;if(panel&&self.root.contains(panel)){self.materializePanel(panel);self.activateTab(parseInt(panel.getAttribute('data-lpd2-tab-index'),10),false);}});this.on(this.quickDialog,'click',function(e){if(e.target===self.quickDialog)closeDialog(self.quickDialog);});this.on(this.quickDialog,'close',function(){document.body.classList.remove(BODY_CLASS);var t=self.quickTrigger;self.quickCard=null;self.quickTrigger=null;if(t&&t.isConnected)t.focus({preventScroll:true});});};

Discovery.prototype.live=function(msg){var el=this.root.querySelector('[data-lpd2-live]');if(!el)return;el.textContent='';setTimeout(function(){el.textContent=msg;},20);};
Discovery.prototype.destroy=function(){if(this.recommendationObserver)this.recommendationObserver.disconnect();this.listeners.forEach(function(x){x[0].removeEventListener(x[1],x[2],x[3]);});this.listeners=[];};

function init(scope){arr((scope||document).querySelectorAll(ROOT)).forEach(function(root){if(!root._lpd2){root._lpd2=new Discovery(root);root._lpd2.init();}});}ready(function(){init(document);});document.addEventListener('shopify:section:load',function(e){init(e.target);});document.addEventListener('shopify:section:unload',function(e){var r=e.target.querySelector(ROOT);if(r&&r._lpd2){r._lpd2.destroy();r._lpd2=null;}});
})();

  } catch(e) { console.error(e); }
})();
})();
